var ln = Object.defineProperty;
var et = (o) => {
  throw TypeError(o);
};
var cn = (o, e, n) => e in o ? ln(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n;
var v = (o, e, n) => cn(o, typeof e != "symbol" ? e + "" : e, n), tt = (o, e, n) => e.has(o) || et("Cannot " + n);
var G = (o, e, n) => (tt(o, e, "read from private field"), n ? n.call(o) : e.get(o)), q = (o, e, n) => e.has(o) ? et("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(o) : e.set(o, n), J = (o, e, n, t) => (tt(o, e, "write to private field"), t ? t.call(o, n) : e.set(o, n), n);
import { inject as we, shallowRef as I, watch as N, onBeforeUnmount as ge, computed as x, defineComponent as O, createElementBlock as k, openBlock as b, Fragment as z, createCommentVNode as E, unref as S, withModifiers as B, createElementVNode as R, renderList as re, createBlock as $, useTemplateRef as Y, provide as De, renderSlot as se, Teleport as ht, onMounted as mt, toDisplayString as dn, normalizeClass as xe, withDirectives as un, normalizeStyle as be, vModelText as hn, nextTick as mn, onUnmounted as gn, createVNode as fn, withCtx as Me } from "vue";
import "typia";
import "reflect-metadata/lite";
import { v4 as Ue } from "uuid";
import { Record as ie, List as Be, Map as pn } from "immutable";
import "typia/lib/internal/_accessExpressionAsString.js";
import yn from "debounce";
import { defineStore as vn } from "pinia";
import { colors as ae } from "@evolutivelabs/unocss-preset-amuse";
const wn = Symbol("isMutable");
function gt() {
  return (o, e) => {
    Reflect.defineMetadata(wn, !0, o, e);
  };
}
function F(o, e) {
  const n = o, t = Object.getPrototypeOf(n), i = Object.getOwnPropertyDescriptors(n), s = Object.create(t, i);
  return e(s), s;
}
function ee({ x: o, y: e }) {
  return Math.hypot(o, e);
}
function ze({ x: o, y: e }, n) {
  return {
    x: o * n,
    y: e * n
  };
}
function ft({ x: o, y: e }, n) {
  const t = Math.sin(n), i = Math.cos(n);
  return {
    x: i * o - t * e,
    y: t * o + i * e
  };
}
function je(o, e) {
  return o.x * e.x + o.y * e.y;
}
function bn(o, e) {
  return o.x * e.y - o.y * e.x;
}
function te(o, e) {
  return {
    x: o.x + e.x,
    y: o.y + e.y
  };
}
function j(o, e) {
  return {
    x: o.x - e.x,
    y: o.y - e.y
  };
}
function _n(o, e) {
  const n = Math.min(je(o, e) / (ee(o) * ee(e)), 1);
  return (bn(o, e) < 0 ? 1 : -1) * Math.acos(n);
}
function kn(o, e) {
  const n = ee(e), t = je(o, e) / Math.pow(n, 2);
  return ze(e, t);
}
class pt {
  constructor(e) {
    v(this, "_data");
    this._data = e;
  }
  get data() {
    return this._data;
  }
  get displayName() {
    return this.name;
  }
  get height() {
    return this._data.height;
  }
  get isVisible() {
    return this._data.isVisible ?? !0;
  }
  get name() {
    return this._data.name;
  }
  get position() {
    return this._data.position;
  }
  get width() {
    return this._data.width;
  }
  static deserialize(e) {
    const n = this.prototype;
    if (!n.isData(e))
      throw new Error(`Data cannot be deserialized to ${n.constructor.name}`);
    return new this(e);
  }
  static serialize(e) {
    return e.data;
  }
  toggleVisibility() {
    this._data = { ...this.data, isVisible: !this.isVisible };
  }
}
class yt {
  constructor() {
    v(this, "_map");
    v(this, "_metadataKey");
    this._metadataKey = Symbol("registryFactoryKey"), this._map = /* @__PURE__ */ new Map();
  }
  deserialize(e) {
    if (!(/* @__PURE__ */ (() => {
      const i = (s) => typeof s.type == "string";
      return (s) => typeof s == "object" && s !== null && i(s);
    })())(e))
      throw new Error("Invalid SerializedWithType");
    const n = e.type, t = this._map.get(n);
    if (t === void 0)
      throw new Error(`Unregistered type: ${n}`);
    return t.deserialize(e.data);
  }
  register(e, n) {
    const t = this._metadataKey, i = n.prototype;
    if (Reflect.hasMetadata(t, i))
      throw new Error(`Constructor is already registered: ${n.name}`);
    const s = this._map;
    if (s.has(e))
      throw new Error(`Type is already registered: ${e}`);
    Reflect.defineMetadata(this._metadataKey, e, i), s.set(e, n);
  }
  registerDecorator(e) {
    return (n) => {
      this.register(e, n);
    };
  }
  serialize(e) {
    const n = this.typeOf(e);
    if (n === void 0)
      throw new Error("Given target is not registered");
    const t = this._map.get(n);
    if (t === void 0)
      throw new Error(`Unregistered type: ${n}`);
    return {
      type: n,
      data: t.serialize(e)
    };
  }
  typeOf(e) {
    return Reflect.getMetadata(this._metadataKey, e);
  }
}
const le = new yt(), vt = le.registerDecorator.bind(le);
var Rn = Object.getOwnPropertyDescriptor, Sn = (o, e, n, t) => {
  for (var i = t > 1 ? void 0 : t ? Rn(e, n) : e, s = o.length - 1, r; s >= 0; s--)
    (r = o[s]) && (i = r(i) || i);
  return i;
};
const wt = "image";
let Fe = class extends pt {
  get creatorId() {
    return this.data.creatorId;
  }
  get id() {
    return this.data.id;
  }
  get imageUrl() {
    return this.data.imageUrl;
  }
  get thumbnailUrl() {
    return this.data.imageUrl;
  }
  isData(o) {
    return (/* @__PURE__ */ (() => {
      const e = (t, i = !0) => typeof t.height == "number" && (t.isVisible === void 0 || typeof t.isVisible == "boolean") && typeof t.name == "string" && typeof t.position == "object" && t.position !== null && n(t.position, i) && typeof t.width == "number" && typeof t.creatorId == "string" && typeof t.id == "string" && typeof t.imageUrl == "string" && (Object.keys(t).length === 7 || Object.keys(t).every((s) => !!(["height", "isVisible", "name", "position", "width", "creatorId", "id", "imageUrl"].some((a) => s === a) || t[s] === void 0))), n = (t, i = !0) => typeof t.x == "number" && typeof t.y == "number" && (Object.keys(t).length === 2 || Object.keys(t).every((s) => !!(["x", "y"].some((a) => s === a) || t[s] === void 0)));
      return (t, i = !0) => typeof t == "object" && t !== null && e(t, !0);
    })())(o);
  }
};
Fe = Sn([
  vt(wt)
], Fe);
function vs(o) {
  return new Fe({ ...o });
}
function Cn(o) {
  return le.typeOf(o) === wt;
}
var En = Object.defineProperty, xn = Object.getOwnPropertyDescriptor, bt = (o, e, n, t) => {
  for (var i = t > 1 ? void 0 : t ? xn(e, n) : e, s = o.length - 1, r; s >= 0; s--)
    (r = o[s]) && (i = (t ? r(e, n, i) : r(i)) || i);
  return t && i && En(e, n, i), i;
};
const _t = "plainColor";
function Mn(o, e, n) {
  const t = `<svg xmlns="http://www.w3.org/2000/svg" width="${e}" height="${n}" viewBox="0 0 ${e} ${n}" style="background:${o}"></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(t).replace(/"/g, "%22")}`;
}
let ye = class extends pt {
  constructor(e) {
    super(e);
    v(this, "_cachedThumbnailUrl");
    this._cachedThumbnailUrl = null;
  }
  get colorCode() {
    return this.data.colorCode;
  }
  get thumbnailUrl() {
    let e = this._cachedThumbnailUrl;
    if (e === null) {
      const { width: n, height: t, colorCode: i } = this;
      e = Mn(i, n, t), this._cachedThumbnailUrl = e;
    }
    return e;
  }
  isData(e) {
    return (/* @__PURE__ */ (() => {
      const n = (i, s = !0) => typeof i.height == "number" && (i.isVisible === void 0 || typeof i.isVisible == "boolean") && typeof i.name == "string" && typeof i.position == "object" && i.position !== null && t(i.position, s) && typeof i.width == "number" && typeof i.colorCode == "string" && (Object.keys(i).length === 5 || Object.keys(i).every((r) => !!(["height", "isVisible", "name", "position", "width", "colorCode"].some((l) => r === l) || i[r] === void 0))), t = (i, s = !0) => typeof i.x == "number" && typeof i.y == "number" && (Object.keys(i).length === 2 || Object.keys(i).every((r) => !!(["x", "y"].some((l) => r === l) || i[r] === void 0)));
      return (i, s = !0) => typeof i == "object" && i !== null && n(i, !0);
    })())(e);
  }
};
bt([
  gt()
], ye.prototype, "_cachedThumbnailUrl", 2);
ye = bt([
  vt(_t)
], ye);
function ws(o) {
  return new ye({ ...o });
}
function Pn(o) {
  return le.typeOf(o) === _t;
}
class $n {
  constructor(e) {
    v(this, "_alignments");
    this._alignments = e ?? [];
  }
  clear() {
    this._alignments.length = 0;
  }
  [Symbol.iterator]() {
    return this._alignments.values();
  }
  update(...e) {
    const n = this._alignments;
    for (const t of e) {
      const i = t.value;
      let s = !1;
      for (const r of n)
        if (r.value === i) {
          r.start = Math.min(r.start, t.start), r.end = Math.max(r.end, t.end), s = !0;
          break;
        }
      s || n.push({ ...t });
    }
  }
}
function ce() {
  return new $n();
}
function On(o, e) {
  let n, t = o;
  for (; t !== void 0 && n === void 0; )
    n = Object.getOwnPropertyDescriptor(t, e), t = Object.getPrototypeOf(t);
  return n;
}
class kt {
  constructor(e, n) {
    v(this, "_options");
    v(this, "_data");
    v(this, "_operatingToken");
    this._options = n, e = this._validateData(e), this._data = e, this._operatingToken = null;
  }
  get _rawHeight() {
    throw new Error("AbstractDesignElement._rawHeight is not implemented");
  }
  get _rawWidth() {
    throw new Error("AbstractDesignElement._rawWidth is not implemented");
  }
  get _updatedData() {
    return {};
  }
  get alignments() {
    const { x: e, y: n, width: t, height: i } = this.boundingRect, s = e + t / 2, r = e + t, a = n + i / 2, l = n + i, c = ce();
    c.update(
      {
        value: e,
        start: n,
        end: l
      },
      {
        value: s,
        start: n,
        end: l
      },
      {
        value: r,
        start: n,
        end: l
      }
    );
    const m = ce();
    return m.update(
      {
        value: n,
        start: e,
        end: r
      },
      {
        value: a,
        start: e,
        end: r
      },
      {
        value: l,
        start: e,
        end: r
      }
    ), {
      x: c,
      y: m
    };
  }
  get angleRadian() {
    return 0;
  }
  get boundingRect() {
    const { x: e, y: n } = this.position, t = this._rawWidth, i = this._rawHeight, s = this._project({ x: 0, y: 0 }), r = this._project({ x: t, y: 0 }), a = this._project({ x: 0, y: i }), l = this._project({ x: t, y: i }), c = Math.min(s.x, r.x, a.x, l.x), m = Math.min(s.y, r.y, a.y, l.y);
    return {
      x: e + c,
      y: n + m,
      width: Math.max(s.x, r.x, a.x, l.x) - c,
      height: Math.max(s.y, r.y, a.y, l.y) - m
    };
  }
  get centerPosition() {
    return this._getCenterPosition();
  }
  get data() {
    return this._data;
  }
  get height() {
    return this._rawHeight;
  }
  get isLocked() {
    return this.data.isLocked ?? !1;
  }
  get isMirrored() {
    return !1;
  }
  get isOperating() {
    return this._operatingToken !== null;
  }
  get isVisible() {
    return this.data.isVisible ?? !0;
  }
  get position() {
    const e = j(this._getCenterPosition(), this._getCenterPosition(!1));
    return j(this.data.position, e);
  }
  get scaleRatio() {
    return 1;
  }
  get width() {
    return this._rawWidth;
  }
  static deserialize(e) {
    const n = this.prototype;
    if (!n.isData(e))
      throw new Error(`Data cannot be deserialized to ${n.constructor.name}`);
    return new this(e);
  }
  static serialize(e) {
    return e.data;
  }
  static withMixin(e) {
    return e(this);
  }
  _as({ prototype: e }) {
    return new Proxy(this, {
      get(n, t, i) {
        var a;
        const s = On(e, t);
        if (s === void 0)
          return Reflect.get(n, t, i);
        const r = (a = s.get) == null ? void 0 : a.bind(n);
        if (r === void 0) {
          const l = s.value;
          return l instanceof Function ? l.bind(n) : l;
        } else
          return r();
      }
    });
  }
  _clearOperating() {
    this._operatingToken = null;
  }
  _getCenterPosition(e = !0) {
    const n = this._rawWidth, t = this._rawHeight;
    return this._project(
      {
        x: n / 2,
        y: t / 2
      },
      e
    );
  }
  _project(e, n = !0) {
    return e;
  }
  _updateData(e) {
    if (this.isOperating)
      throw new Error("Operating element cannot be updated");
    if (this.isLocked)
      throw new Error("Locked element cannot be updated");
    this._data = this._validateData(e);
  }
  _validateData(e) {
    return e;
  }
  assertValidToken(e) {
    if (e !== this._operatingToken)
      throw new Error("Invalid token for the operating element");
  }
  clearOperating(e) {
    this.assertValidToken(e), this._clearOperating();
  }
  endOperating(e) {
    this.assertValidToken(e), this._operatingToken = null, this._updateData({
      ...this.data,
      ...this._updatedData,
      position: this.position
    }), this._clearOperating();
  }
  startOperating(e) {
    if (this.isOperating)
      throw new Error("Element is already in operating state");
    if (this.isLocked)
      throw new Error("Locked element cannot be operated");
    this._operatingToken = e;
  }
  toggleLock() {
    if (!this.isLocked && this.isOperating)
      throw new Error("Operating element cannot be locked");
    this._data = { ...this.data, isLocked: !this.isLocked };
  }
  toggleVisibility() {
    this._data = { ...this.data, isVisible: !this.isVisible };
  }
  updateData(e) {
    if (!this.isData(e))
      throw new Error("Invalid data for updating the element");
    this._updateData(e);
  }
}
class Ie extends kt {
  get _rawHeight() {
    return this.data.height;
  }
  get _rawWidth() {
    return this.data.width;
  }
}
const Rt = Symbol("cloneable symbol");
function Tn(o) {
  const e = Object.getPrototypeOf(o);
  return Reflect.getOwnMetadata(Rt, e) === !0;
}
function _e() {
  return ({
    prototype: o
  }) => {
    Reflect.defineMetadata(Rt, !0, o);
  };
}
const St = Symbol("movable symbol");
function Dn(o) {
  return Reflect.getMetadata(St, o) === !0;
}
const Bn = ie({ offset: { x: 0, y: 0 } });
function nt(o, e, n, t) {
  let i = t, s = 0;
  const r = ce();
  for (const a of n) {
    const l = a.value - o, c = l - e / 2, m = l - e, d = Math.min(Math.abs(l), Math.abs(c), Math.abs(m));
    d < i && (r.clear(), i = d, Math.abs(l) === d ? s = l : Math.abs(c) === d ? s = c : s = m), d === i && r.update(a);
  }
  return [r, s];
}
function ke(o) {
  var t, i;
  const e = Symbol("operating-state symbol");
  class n extends (i = o, t = e, i) {
    constructor() {
      super(...arguments);
      v(this, t, Bn());
    }
    get _updatedData() {
      return {
        ...super._updatedData,
        position: this._as(n).position
      };
    }
    get position() {
      return te(super.position, this[e].offset);
    }
    _clearOperating() {
      this[e] = this[e].clear(), super._clearOperating();
    }
    horizontallyCenterToPage({ width: a, x: l }) {
      const c = Symbol("operating token");
      this.startOperating(c), this.updateMoveOffset(c, {
        x: l + a / 2 - this.position.x - this.centerPosition.x,
        y: 0
      }), this.endOperating(c);
    }
    updateMoveOffset(a, l, c) {
      this.assertValidToken(a);
      let m;
      if (c === void 0)
        m = {
          x: [],
          y: []
        };
      else {
        const d = this._options.minMoveAlignDiff ?? 20, u = this[e].offset, { x: y, y: g, width: f, height: h } = this.boundingRect, w = y + l.x - u.x, [p, _] = nt(w, f, c.x, d), C = g + l.y - u.y, [M, T] = nt(C, h, c.y, d), V = C + T, U = V + h;
        for (const D of p)
          D.start = Math.min(D.start, V), D.end = Math.max(D.end, U);
        const L = w + _, W = L + f;
        for (const D of M)
          D.start = Math.min(D.start, L), D.end = Math.max(D.end, W);
        m = {
          x: p,
          y: M
        }, l = {
          x: l.x + _,
          y: l.y + T
        };
      }
      return this[e] = this[e].set("offset", l), m;
    }
    verticallyCenterToPage({ height: a, y: l }) {
      const c = Symbol("operating token");
      this.startOperating(c), this.updateMoveOffset(c, {
        x: 0,
        y: l + a / 2 - this.position.y - this.centerPosition.y
      }), this.endOperating(c);
    }
  }
  return Reflect.defineMetadata(St, !0, n.prototype), n;
}
const A = new yt(), Re = A.registerDecorator.bind(A), Ct = Symbol("rotatable symbol");
function Fn(o) {
  return Reflect.getMetadata(Ct, o) === !0;
}
function ot(o) {
  const e = o * (180 / Math.PI);
  return ((Math.round(e) % 360 - 540) % 360 + 180) * (Math.PI / 180);
}
const Ln = ie({
  angleRadian: 0,
  isRotating: !1
});
function Se(o) {
  var t, i;
  const e = Symbol("operating-state symbol");
  class n extends (i = o, t = e, i) {
    constructor() {
      super(...arguments);
      v(this, t, Ln());
    }
    get _updatedData() {
      return {
        ...super._updatedData,
        angleRadian: this._as(n).angleRadian
      };
    }
    get angleRadian() {
      return ot(
        (this.data.angleRadian ?? 0) + this[e].angleRadian
      );
    }
    get isRotating() {
      return this[e].isRotating;
    }
    _clearOperating() {
      this[e] = this[e].clear(), super._clearOperating();
    }
    _project(a, l = !0) {
      const c = l ? this._as(n).angleRadian : this.data.angleRadian ?? 0;
      return ft(super._project(a, l), c);
    }
    _validateData(a) {
      return a = super._validateData(a), {
        ...a,
        angleRadian: ot(a.angleRadian ?? 0)
      };
    }
    updateAngleRadian(a, l) {
      this.assertValidToken(a), this[e] = this[e].merge({
        angleRadian: l,
        isRotating: !0
      });
    }
  }
  return Reflect.defineMetadata(Ct, !0, n.prototype), n;
}
const Et = Symbol("scalable symbol");
function An(o) {
  return Reflect.getMetadata(Et, o) === !0;
}
const Vn = ie({ scaleRatio: 1 });
function Ce(o) {
  var t, i;
  const e = Symbol("operating-state symbol");
  class n extends (i = o, t = e, i) {
    constructor() {
      super(...arguments);
      v(this, t, Vn());
    }
    get _updatedData() {
      return {
        ...super._updatedData,
        scaleRatio: this._as(n).scaleRatio
      };
    }
    get height() {
      return super.height * this._as(n).scaleRatio;
    }
    get scaleRatio() {
      return (this.data.scaleRatio ?? 1) * this[e].scaleRatio;
    }
    get width() {
      return super.width * this._as(n).scaleRatio;
    }
    _clearOperating() {
      this[e] = this[e].clear(), super._clearOperating();
    }
    _project(a, l = !0) {
      const c = l ? this._as(n).scaleRatio : this.data.scaleRatio ?? 1;
      return ze(super._project(a, l), c);
    }
    _validateData(a) {
      return a = super._validateData(a), {
        ...a,
        scaleRatio: Math.max(a.scaleRatio ?? 1, this._options.minScaleRatio ?? 0)
      };
    }
    updateScaleRatio(a, l) {
      this.assertValidToken(a), (this.data.scaleRatio ?? 1) * l >= (this._options.minScaleRatio ?? 0) && (this[e] = this[e].set("scaleRatio", l));
    }
  }
  return Reflect.defineMetadata(Et, !0, n.prototype), n;
}
var Un = Object.defineProperty, zn = Object.getOwnPropertyDescriptor, jn = (o, e, n) => e in o ? Un(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, In = (o, e, n, t) => {
  for (var i = t > 1 ? void 0 : t ? zn(e, n) : e, s = o.length - 1, r; s >= 0; s--)
    (r = o[s]) && (i = r(i) || i);
  return i;
}, Wn = (o, e, n) => jn(o, e + "", n);
const xt = "barcode";
let ne = class extends Ie.withMixin(Ce).withMixin(Se).withMixin(ke) {
  constructor(o) {
    super(o, ne.options);
  }
  get displayName() {
    return this.name;
  }
  get imageUrl() {
    return this.data.imageUrl;
  }
  get name() {
    return this.data.name;
  }
  get thumbnailUrl() {
    return this.data.imageUrl;
  }
  isData(o) {
    return (/* @__PURE__ */ (() => {
      const e = (t, i = !0) => typeof t.imageUrl == "string" && typeof t.name == "string" && typeof t.height == "number" && typeof t.width == "number" && (t.isLocked === void 0 || typeof t.isLocked == "boolean") && (t.isVisible === void 0 || typeof t.isVisible == "boolean") && typeof t.position == "object" && t.position !== null && n(t.position, i) && (t.angleRadian === void 0 || typeof t.angleRadian == "number") && (t.scaleRatio === void 0 || typeof t.scaleRatio == "number") && (Object.keys(t).length === 5 || Object.keys(t).every((s) => !!(["imageUrl", "name", "height", "width", "isLocked", "isVisible", "position", "angleRadian", "scaleRatio"].some((a) => s === a) || t[s] === void 0))), n = (t, i = !0) => typeof t.x == "number" && typeof t.y == "number" && (Object.keys(t).length === 2 || Object.keys(t).every((s) => !!(["x", "y"].some((a) => s === a) || t[s] === void 0)));
      return (t, i = !0) => typeof t == "object" && t !== null && e(t, !0);
    })())(o);
  }
};
Wn(ne, "options", {});
ne = In([
  Re(xt),
  _e()
], ne);
function bs(o) {
  ne.options = o;
}
function _s(o) {
  return new ne(o);
}
function Gn(o) {
  return A.typeOf(o) === xt;
}
const Mt = Symbol("bordered symbol");
function ks(o) {
  return Reflect.getMetadata(Mt, o) === !0;
}
function Hn(o) {
  class e extends o {
    get borderColor() {
      return this.data.borderColor;
    }
    get borderRadius() {
      return this.data.borderRadius ?? 0;
    }
    get borderWidth() {
      return this.data.borderWidth ?? 0;
    }
    _validateData(t) {
      return t = super._validateData(t), {
        ...t,
        borderRadius: Math.min(Math.max(0, t.borderRadius ?? 0), 100),
        borderWidth: Math.max(0, t.borderWidth ?? 0)
      };
    }
    setBorderColor(t) {
      this._updateData({ ...this.data, borderColor: t });
    }
    setBorderRadius(t) {
      this._updateData({ ...this.data, borderRadius: t });
    }
    setBorderWidth(t) {
      this._updateData({ ...this.data, borderWidth: t });
    }
  }
  return Reflect.defineMetadata(Mt, !0, e.prototype), e;
}
var Nn = Object.defineProperty, Yn = (o, e, n, t) => {
  for (var i = void 0, s = o.length - 1, r; s >= 0; s--)
    (r = o[s]) && (i = r(e, n, i) || i);
  return i && Nn(e, n, i), i;
};
const Pt = Symbol("content-editable symbol");
function We(o) {
  return Reflect.getMetadata(Pt, o) === !0;
}
const it = ie({
  isContentEditing: !1,
  content: ""
});
function Xn(o) {
  var r, a, l;
  var e;
  const n = Symbol("operating-state symbol"), t = Symbol("getBBox symbol"), i = class $t extends (l = o, a = e = t, r = n, l) {
    constructor() {
      super(...arguments);
      v(this, a);
      v(this, r, it({ content: this.data.content }));
    }
    get _rawHeight() {
      var d;
      return ((d = this[t]) == null ? void 0 : d.call(this).height) ?? 0;
    }
    get _rawWidth() {
      var d;
      return ((d = this[t]) == null ? void 0 : d.call(this).width) ?? 0;
    }
    get _updatedData() {
      const d = this._as($t);
      return {
        ...super._updatedData,
        content: d.content,
        fontFamily: d.fontFamily,
        color: d.color,
        backgroundColor: d.backgroundColor,
        backgroundRadius: d.backgroundRadius
      };
    }
    get backgroundColor() {
      return this.data.backgroundColor;
    }
    get backgroundPadding() {
      return 2;
    }
    get backgroundRadius() {
      return this.data.backgroundRadius ?? 0;
    }
    get color() {
      return this.data.color;
    }
    get content() {
      const d = this[n];
      return d.isContentEditing ? d.content : this.data.content;
    }
    get curvature() {
      return this.data.curvature ?? 0;
    }
    get fontFamily() {
      return this.data.fontFamily;
    }
    get isContentEditing() {
      return this[n].isContentEditing;
    }
    get isVisible() {
      return super.isVisible && !this[n].isContentEditing;
    }
    get leading() {
      var d;
      return ((d = this[t]) == null ? void 0 : d.call(this).y) ?? 0;
    }
    _clearOperating() {
      this[n] = it({ content: this.data.content }), super._clearOperating();
    }
    _validateData(d) {
      return d = super._validateData(d), {
        ...d,
        curvature: Math.min(Math.max(d.curvature ?? 0, 0), 100)
      };
    }
    changeBackgroundColor(d) {
      this._updateData({ ...this.data, backgroundColor: d });
    }
    changeBackgroundRadius(d) {
      this._updateData({ ...this.data, backgroundRadius: d });
    }
    changeColor(d) {
      this._updateData({ ...this.data, color: d });
    }
    changeFontFamily(d) {
      this._updateData({ ...this.data, fontFamily: d });
    }
    setBoxSizeGetter(d) {
      this[t] = d;
    }
    setCurvature(d) {
      this._updateData({ ...this.data, curvature: d });
    }
    startEditContent(d) {
      this.assertValidToken(d), this[n] = this[n].set("isContentEditing", !0);
    }
    updateContent(d, u) {
      if (this.assertValidToken(d), !this.isContentEditing)
        throw new Error(
          "ContentEditableElement#startEditContent() must be invoked before updateContent()"
        );
      this[n] = this[n].set("content", u);
    }
  };
  Yn([
    gt()
  ], i.prototype, e);
  let s = i;
  return Reflect.defineMetadata(
    Pt,
    !0,
    s.prototype
  ), s;
}
const Ot = Symbol("croppable symbol");
function Kn(o) {
  return Reflect.getMetadata(Ot, o) === !0;
}
const Zn = ie({
  clipTopOffset: 0,
  clipBottomOffset: 0,
  clipLeftOffset: 0,
  clipRightOffset: 0
});
function qn(o) {
  var t, i;
  const e = Symbol("operating-state symbol");
  class n extends (i = o, t = e, i) {
    constructor() {
      super(...arguments);
      v(this, t, Zn());
    }
    get _clipLeft() {
      return (this.data.clipLeft ?? 0) + this[e].clipLeftOffset;
    }
    get _clipRight() {
      return (this.data.clipRight ?? 0) + this[e].clipRightOffset;
    }
    get _rawHeight() {
      return super._rawHeight - this.clipTop - this.clipBottom;
    }
    get _rawWidth() {
      return super._rawWidth - this.clipLeft - this.clipRight;
    }
    get _updatedData() {
      const a = this._as(n);
      return {
        ...super._updatedData,
        clipTop: a.clipTop,
        clipLeft: a._clipLeft,
        clipBottom: a.clipBottom,
        clipRight: a._clipRight
      };
    }
    get clipBottom() {
      return (this.data.clipBottom ?? 0) + this[e].clipBottomOffset;
    }
    get clipLeft() {
      return this.isMirrored ? this._clipRight : this._clipLeft;
    }
    get clipRight() {
      return this.isMirrored ? this._clipLeft : this._clipRight;
    }
    get clipTop() {
      return (this.data.clipTop ?? 0) + this[e].clipTopOffset;
    }
    get originHeight() {
      return super._rawHeight;
    }
    get originWidth() {
      return super._rawWidth;
    }
    get position() {
      const a = this[e];
      return te(
        super.position,
        this._project({
          x: this.isMirrored ? a.clipRightOffset : a.clipLeftOffset,
          y: a.clipTopOffset
        })
      );
    }
    _clearOperating() {
      this[e] = this[e].clear(), super._clearOperating();
    }
    updateCropState(a, {
      clipTopOffset: l = 0,
      clipLeftOffset: c = 0,
      clipBottomOffset: m = 0,
      clipRightOffset: d = 0
    }) {
      this.assertValidToken(a), this.isMirrored && ([d, c] = [c, d]);
      const u = this._options.minCroppedSize ?? 0, { clipLeft: y = 0, clipRight: g = 0, clipTop: f = 0, clipBottom: h = 0 } = this.data;
      super._rawWidth - y - g - c - d < u || super._rawHeight - f - h - l - m < u || (this[e] = this[e].merge({
        clipTopOffset: Math.max(l, -f),
        clipLeftOffset: Math.max(c, -y),
        clipBottomOffset: Math.max(m, -h),
        clipRightOffset: Math.max(d, -g)
      }));
    }
  }
  return Reflect.defineMetadata(Ot, !0, n.prototype), n;
}
const Tt = Symbol("full-pageable symbol");
function Jn(o) {
  return Reflect.getMetadata(Tt, o) === !0;
}
function Qn(o) {
  class e extends o {
    expandToFullPage({ width: t, height: i, x: s, y: r }) {
      const a = Symbol("operatingToken");
      this.startOperating(a);
      const l = this._as(e);
      l.updateAngleRadian(a, -l.angleRadian);
      const c = Math.max(t / l.width, i / l.height);
      l.updateScaleRatio(a, c);
      const m = l.position;
      l.updateMoveOffset(a, {
        x: s + (t - l.width) / 2 - m.x,
        y: r + (i - l.height) / 2 - m.y
      }), this.endOperating(a);
    }
  }
  return Reflect.defineMetadata(Tt, !0, e.prototype), e;
}
const Dt = Symbol("mirrorable symbol");
function eo(o) {
  return Reflect.getMetadata(Dt, o) === !0;
}
function to(o) {
  class e extends o {
    get isMirrored() {
      return this.data.isMirrored ?? !1;
    }
    mirror() {
      this._updateData({ ...this.data, isMirrored: !this.isMirrored });
    }
  }
  return Reflect.defineMetadata(Dt, !0, e.prototype), e;
}
var no = Object.getOwnPropertyDescriptor, oo = (o, e, n, t) => {
  for (var i = t > 1 ? void 0 : t ? no(e, n) : e, s = o.length - 1, r; s >= 0; s--)
    (r = o[s]) && (i = r(i) || i);
  return i;
};
const Bt = "photo";
let Le = class extends Ie.withMixin(Hn).withMixin(qn).withMixin(Ce).withMixin(Se).withMixin(to).withMixin(ke).withMixin(Qn) {
  constructor(o) {
    super(o, { minCroppedSize: 20 });
  }
  get displayName() {
    return this.name;
  }
  get imageUrl() {
    return this.data.imageUrl;
  }
  get name() {
    return this.data.name;
  }
  get thumbnailUrl() {
    return this.imageUrl;
  }
  isData(o) {
    return (/* @__PURE__ */ (() => {
      const e = (t, i = !0) => (t.isLocked === void 0 || typeof t.isLocked == "boolean") && (t.isVisible === void 0 || typeof t.isVisible == "boolean") && typeof t.position == "object" && t.position !== null && n(t.position, i) && (t.borderColor === void 0 || typeof t.borderColor == "string") && (t.borderRadius === void 0 || typeof t.borderRadius == "number") && (t.borderWidth === void 0 || typeof t.borderWidth == "number") && (t.clipBottom === void 0 || typeof t.clipBottom == "number") && (t.clipLeft === void 0 || typeof t.clipLeft == "number") && (t.clipRight === void 0 || typeof t.clipRight == "number") && (t.clipTop === void 0 || typeof t.clipTop == "number") && typeof t.height == "number" && typeof t.width == "number" && (t.isMirrored === void 0 || typeof t.isMirrored == "boolean") && (t.angleRadian === void 0 || typeof t.angleRadian == "number") && (t.scaleRatio === void 0 || typeof t.scaleRatio == "number") && typeof t.imageUrl == "string" && typeof t.name == "string" && (Object.keys(t).length === 5 || Object.keys(t).every((s) => !!(["isLocked", "isVisible", "position", "borderColor", "borderRadius", "borderWidth", "clipBottom", "clipLeft", "clipRight", "clipTop", "height", "width", "isMirrored", "angleRadian", "scaleRatio", "imageUrl", "name"].some((a) => s === a) || t[s] === void 0))), n = (t, i = !0) => typeof t.x == "number" && typeof t.y == "number" && (Object.keys(t).length === 2 || Object.keys(t).every((s) => !!(["x", "y"].some((a) => s === a) || t[s] === void 0)));
      return (t, i = !0) => typeof t == "object" && t !== null && e(t, !0);
    })())(o);
  }
};
Le = oo([
  Re(Bt),
  _e()
], Le);
function Rs(o) {
  return new Le(o);
}
function io(o) {
  return A.typeOf(o) === Bt;
}
const Ft = Symbol("stackable symbol");
function st(o) {
  return Math.max(Math.floor(o), 1);
}
function rt(o) {
  return Math.max(Math.min(1, o), -1);
}
function Ss(o) {
  return Reflect.getMetadata(Ft, o) === !0;
}
function so(o) {
  class e extends o {
    get _rawHeight() {
      const { numStackRows: t = 1 } = this.data, { stackGap: i } = this;
      return (super._rawHeight + i) * t - i;
    }
    get _rawWidth() {
      const { numStackColumns: t = 1 } = this.data, { stackGap: i } = this;
      return (super._rawWidth + i) * t - i;
    }
    get numStackColumns() {
      return this.data.numStackColumns ?? 1;
    }
    get numStackRows() {
      return this.data.numStackRows ?? 1;
    }
    get originHeight() {
      return super._rawHeight;
    }
    get originWidth() {
      return super._rawWidth;
    }
    get stackGap() {
      return this.originWidth * this.stackGapRatio;
    }
    get stackGapRatio() {
      return this.data.stackGapRatio ?? 0;
    }
    get stackOffset() {
      return (this.originWidth + this.stackGap) * this.stackOffsetRatio;
    }
    get stackOffsetRatio() {
      return this.data.stackOffsetRatio ?? 0;
    }
    _validateData(t) {
      return t = super._validateData(t), {
        ...t,
        stackGapRatio: rt(t.stackGapRatio ?? 0),
        stackOffsetRatio: rt(t.stackOffsetRatio ?? 0),
        numStackRows: st(t.numStackRows ?? 1),
        numStackColumns: st(t.numStackColumns ?? 1)
      };
    }
    setNumStackColumns(t) {
      this._updateData({ ...this.data, numStackColumns: t });
    }
    setNumStackRows(t) {
      this._updateData({ ...this.data, numStackRows: t });
    }
    setStackGapRatio(t) {
      this._updateData({ ...this.data, stackGapRatio: t });
    }
    setStackOffsetRatio(t) {
      this._updateData({ ...this.data, stackOffsetRatio: t });
    }
  }
  return Reflect.defineMetadata(Ft, !0, e.prototype), e;
}
var ro = Object.getOwnPropertyDescriptor, ao = (o, e, n, t) => {
  for (var i = t > 1 ? void 0 : t ? ro(e, n) : e, s = o.length - 1, r; s >= 0; s--)
    (r = o[s]) && (i = r(i) || i);
  return i;
};
const Lt = "sticker";
let Ae = class extends Ie.withMixin(so).withMixin(Ce).withMixin(Se).withMixin(ke) {
  constructor(o) {
    super(o, {});
  }
  get creatorId() {
    return this.data.creatorId;
  }
  get displayName() {
    return this.name;
  }
  get groupId() {
    return this.data.groupId;
  }
  get imageUrl() {
    return this.data.imageUrl;
  }
  get name() {
    return this.data.name;
  }
  get stickerId() {
    return this.data.stickerId;
  }
  get thumbnailUrl() {
    return this.data.thumbnailUrl;
  }
  isData(o) {
    return (/* @__PURE__ */ (() => {
      const e = (t, i = !0) => typeof t.imageUrl == "string" && typeof t.name == "string" && typeof t.creatorId == "string" && typeof t.groupId == "string" && typeof t.stickerId == "string" && typeof t.thumbnailUrl == "string" && typeof t.height == "number" && typeof t.width == "number" && (t.isLocked === void 0 || typeof t.isLocked == "boolean") && (t.isVisible === void 0 || typeof t.isVisible == "boolean") && typeof t.position == "object" && t.position !== null && n(t.position, i) && (t.angleRadian === void 0 || typeof t.angleRadian == "number") && (t.scaleRatio === void 0 || typeof t.scaleRatio == "number") && (t.numStackColumns === void 0 || typeof t.numStackColumns == "number") && (t.numStackRows === void 0 || typeof t.numStackRows == "number") && (t.stackGapRatio === void 0 || typeof t.stackGapRatio == "number") && (t.stackOffsetRatio === void 0 || typeof t.stackOffsetRatio == "number") && (Object.keys(t).length === 9 || Object.keys(t).every((s) => !!(["imageUrl", "name", "creatorId", "groupId", "stickerId", "thumbnailUrl", "height", "width", "isLocked", "isVisible", "position", "angleRadian", "scaleRatio", "numStackColumns", "numStackRows", "stackGapRatio", "stackOffsetRatio"].some((a) => s === a) || t[s] === void 0))), n = (t, i = !0) => typeof t.x == "number" && typeof t.y == "number" && (Object.keys(t).length === 2 || Object.keys(t).every((s) => !!(["x", "y"].some((a) => s === a) || t[s] === void 0)));
      return (t, i = !0) => typeof t == "object" && t !== null && e(t, !0);
    })())(o);
  }
};
Ae = ao([
  Re(Lt),
  _e()
], Ae);
function Cs(o) {
  return new Ae(o);
}
function lo(o) {
  return A.typeOf(o) === Lt;
}
const co = "data:image/svg+xml,%3csvg%20width='48'%20height='48'%20viewBox='0%200%2048%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='48'%20height='48'%20fill='%23F3F4F2'/%3e%3cpath%20d='M22.5939%2032.8384H25.3779V17.5024H30.5859V15.1504H17.4099V17.5024H22.5939V32.8384Z'%20fill='%233C4238'/%3e%3c/svg%3e";
var uo = Object.defineProperty, ho = Object.getOwnPropertyDescriptor, mo = (o, e, n) => e in o ? uo(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, go = (o, e, n, t) => {
  for (var i = t > 1 ? void 0 : t ? ho(e, n) : e, s = o.length - 1, r; s >= 0; s--)
    (r = o[s]) && (i = r(i) || i);
  return i;
}, fo = (o, e, n) => mo(o, e + "", n);
const At = "text";
let oe = class extends kt.withMixin(Xn).withMixin(Ce).withMixin(Se).withMixin(ke) {
  constructor(o) {
    super(o, oe.options);
  }
  get displayName() {
    return this.content;
  }
  get thumbnailUrl() {
    return co;
  }
  isData(o) {
    return (/* @__PURE__ */ (() => {
      const e = (t, i = !0) => (t.isLocked === void 0 || typeof t.isLocked == "boolean") && (t.isVisible === void 0 || typeof t.isVisible == "boolean") && typeof t.position == "object" && t.position !== null && n(t.position, i) && (t.backgroundColor === void 0 || typeof t.backgroundColor == "string") && (t.backgroundRadius === void 0 || typeof t.backgroundRadius == "number") && typeof t.color == "string" && typeof t.content == "string" && (t.curvature === void 0 || typeof t.curvature == "number") && typeof t.fontFamily == "string" && (t.angleRadian === void 0 || typeof t.angleRadian == "number") && (t.scaleRatio === void 0 || typeof t.scaleRatio == "number") && (Object.keys(t).length === 4 || Object.keys(t).every((s) => !!(["isLocked", "isVisible", "position", "backgroundColor", "backgroundRadius", "color", "content", "curvature", "fontFamily", "angleRadian", "scaleRatio"].some((a) => s === a) || t[s] === void 0))), n = (t, i = !0) => typeof t.x == "number" && typeof t.y == "number" && (Object.keys(t).length === 2 || Object.keys(t).every((s) => !!(["x", "y"].some((a) => s === a) || t[s] === void 0)));
      return (t, i = !0) => typeof t == "object" && t !== null && e(t, !0);
    })())(o);
  }
};
fo(oe, "options", {});
oe = go([
  Re(At),
  _e()
], oe);
function Es(o) {
  oe.options = o;
}
function xs(o) {
  return new oe(o);
}
function po(o) {
  return A.typeOf(o) === At;
}
class yo {
  constructor(e) {
    v(this, "_map");
    v(this, "_order");
    const n = [];
    for (const [t, i] of e ?? [])
      n.push(t);
    this._order = Be(n), this._map = pn(e);
  }
  get size() {
    return this._map.size;
  }
  get [Symbol.toStringTag]() {
    return "ReorderableMap";
  }
  clear() {
    this._order = this._order.clear(), this._map = this._map.clear();
  }
  delete(e) {
    const n = this._map, t = n.has(e);
    if (t) {
      const i = this._order, s = i.indexOf(e);
      this._order = i.splice(s, 1), this._map = n.delete(e);
    }
    return t;
  }
  *entries() {
    const e = this._map;
    for (const n of this._order)
      yield [n, e.get(n)];
  }
  forEach(e, n) {
    for (const [t, i] of this)
      e.call(n, i, t, this);
  }
  get(e) {
    return this._map.get(e);
  }
  has(e) {
    return this._map.has(e);
  }
  indexOf(e) {
    return this._order.indexOf(e);
  }
  keyOf(e) {
    return this._map.keyOf(e);
  }
  keys() {
    return this._order.values();
  }
  move(e, n) {
    const t = this.indexOf(e);
    if (t < 0)
      throw new RangeError(`Key not found in the map: ${String(e)}`);
    const i = this.size, s = n < 0 ? Math.max(i + n, 0) : Math.min(n, i - 1);
    return this._order = this._order.splice(t, 1).splice(s, 0, e), this;
  }
  set(e, n) {
    const t = this._map;
    return t.has(e) || (this._order = this._order.push(e)), this._map = t.set(e, n), this;
  }
  [Symbol.iterator]() {
    return this.entries();
  }
  *values() {
    const e = this._map;
    for (const n of this._order)
      yield e.get(n);
  }
}
function Vt(o) {
  return new yo(o);
}
class vo extends ie({
  background: null,
  elements: Vt()
}) {
}
function Ut(o) {
  return new vo(o);
}
class wo {
  constructor(e) {
    v(this, "_element");
    v(this, "_id");
    this._element = e;
  }
  get elementId() {
    return this._id;
  }
  execute(e, n, t = F) {
    let i = e.elements, s;
    do
      s = Ue();
    while (i.has(s));
    return i = t(i, (r) => {
      r.set(s, this._element);
    }), this._id = s, { state: e.set("elements", i) };
  }
}
class P {
  constructor(e) {
    v(this, "_element");
    this._element = e;
  }
  execute(e, n, t = F) {
    let i = e.elements, s = this._element;
    const r = i.keyOf(s);
    if (r === void 0)
      throw new Error("Element without ID is invalid");
    return s = t(this._element, (a) => {
      this._execute(a);
    }), i = t(i, (a) => {
      a.set(r, s);
    }), { state: e.set("elements", i) };
  }
}
class Ms extends P {
  constructor(n, t) {
    super(n);
    v(this, "_backgroundColor");
    this._backgroundColor = t;
  }
  _execute(n) {
    n.changeBackgroundColor(this._backgroundColor);
  }
}
class Ps extends P {
  constructor(n, t) {
    super(n);
    v(this, "_backgroundRadius");
    this._backgroundRadius = t;
  }
  _execute(n) {
    n.changeBackgroundRadius(this._backgroundRadius);
  }
}
class $s extends P {
  constructor(n, t) {
    super(n);
    v(this, "_color");
    this._color = t;
  }
  _execute(n) {
    n.changeColor(this._color);
  }
}
class Os extends P {
  constructor(n, t) {
    super(n);
    v(this, "_fontFamily");
    this._fontFamily = t;
  }
  _execute(n) {
    n.changeFontFamily(this._fontFamily);
  }
}
class bo {
  execute(e) {
    return { state: e.clear() };
  }
}
class Ts {
  constructor(e) {
    v(this, "_commands");
    this._commands = e;
  }
  execute(e, n) {
    for (const t of this._commands)
      e = t.execute(e, n).state;
    return { state: e };
  }
}
const pe = Symbol("handler metadata key");
class at {
  constructor(e, n, t) {
    v(this, "_element");
    v(this, "_elementId");
    v(this, "_operatingToken");
    this._elementId = e, this._element = n, this._operatingToken = t;
  }
  execute(e) {
    const n = F(e.elements, (t) => {
      t.set(this._elementId, this._element);
    });
    return {
      state: e.set("elements", n),
      operatingToken: this._operatingToken
    };
  }
}
class fe {
  constructor(e) {
    v(this, "_element");
    this._element = e;
  }
  static register(e) {
    if (Reflect.hasMetadata(pe, this))
      throw new Error(`Handler is already registered: ${this.name}`);
    return Reflect.defineMetadata(pe, e, this), () => {
      Reflect.deleteMetadata(pe, this);
    };
  }
  _endOperating(e, n) {
    e.endOperating(n);
  }
  _startOperating(e, n) {
    e.startOperating(n);
  }
  execute(e, n) {
    const t = Reflect.getOwnMetadata(pe, this.constructor);
    if (t === void 0)
      throw new Error(`Handler not found: ${this.constructor.name}`);
    let i = e.elements, s = this._element;
    const r = i.keyOf(s);
    if (r === void 0)
      throw new Error("Invalid element for performaing command ");
    const a = Symbol("operating token");
    return s = F(s, (l) => {
      this._startOperating(l, a);
    }), i = F(i, (l) => {
      l.set(r, s);
    }), e = e.set("elements", i), t({
      update: (...l) => {
        s = F(s, (m) => {
          this._onUpdate(m, a, ...l);
        });
        const c = new at(r, s, a);
        n(c, { operatingToken: a, ignoreHistory: !0 });
      },
      done: () => {
        s = F(s, (c) => {
          this._endOperating(c, a);
        });
        const l = new at(r, s);
        n(l, { operatingToken: a, ignoreHistory: !0 });
      }
    }), { state: e, operatingToken: a };
  }
}
class H extends fe {
  constructor(n, t, i, s) {
    super(n);
    v(this, "_cropOffsetType");
    v(this, "_startPoint");
    v(this, "_unitVector");
    this._startPoint = t, this._unitVector = ft(i, n.angleRadian), this._cropOffsetType = s;
  }
  static create(n, t, i) {
    switch (i) {
      case "bottom":
        return new H(n, t, { x: 0, y: -1 }, "clipBottomOffset");
      case "left":
        return new H(n, t, { x: 1, y: 0 }, "clipLeftOffset");
      case "right":
        return new H(n, t, { x: -1, y: 0 }, "clipRightOffset");
      case "top":
        return new H(n, t, { x: 0, y: 1 }, "clipTopOffset");
    }
  }
  _onUpdate(n, t, i) {
    const s = this._unitVector, r = j(i, this._startPoint), a = kn(r, s), l = je(s, a) > 0 ? 1 : -1;
    n.updateCropState(t, {
      [this._cropOffsetType]: l * ee(a) / n.scaleRatio
    });
  }
}
class zt extends fe {
  _onUpdate(e, n, t) {
    e.updateContent(n, t);
  }
  _startOperating(e, n) {
    super._startOperating(e, n), e.startEditContent(n);
  }
}
class _o extends P {
  constructor(n, t) {
    super(n);
    v(this, "_targetArea");
    this._targetArea = t;
  }
  _execute(n) {
    n.expandToFullPage(this._targetArea);
  }
}
class Ds extends P {
  constructor(n, t) {
    super(n);
    v(this, "_targetArea");
    this._targetArea = t;
  }
  _execute(n) {
    n.horizontallyCenterToPage(this._targetArea);
  }
}
class ko extends P {
  constructor(e) {
    super(e);
  }
  _execute(e) {
    e.mirror();
  }
}
class lt extends fe {
  constructor(n, t, i) {
    super(n);
    v(this, "_alignments");
    v(this, "_initialPosition");
    v(this, "_onAlign");
    this._initialPosition = t, this._alignments = { x: ce(), y: ce() }, this._onAlign = i;
  }
  _endOperating(n, t) {
    super._endOperating(n, t), this._onAlign({ x: [], y: [] });
  }
  _onUpdate(n, t, i) {
    const s = n.updateMoveOffset(
      t,
      j(i, this._initialPosition),
      this._alignments
    );
    this._onAlign(s);
  }
  execute(n, t) {
    const i = this._element, { x: s, y: r } = this._alignments;
    for (const a of n.elements.values())
      if (a !== i && a.isVisible) {
        const l = a.alignments;
        s.update(...l.x), r.update(...l.y);
      }
    return super.execute(n, t);
  }
}
class Ro {
  constructor(e) {
    v(this, "_element");
    this._element = e;
  }
  execute(e, n, t = F) {
    let i = e.elements;
    const s = i.keyOf(this._element);
    if (s === void 0)
      throw new Error("Element to remove not found");
    return i = t(i, (r) => {
      r.delete(s);
    }), { state: e.set("elements", i) };
  }
}
class So {
  constructor(e, n) {
    v(this, "_id");
    v(this, "_to");
    this._id = e, this._to = n;
  }
  execute(e, n, t = F) {
    let i = e.elements;
    const s = this._id;
    return i = t(i, (r) => {
      r.move(s, this._to);
    }), { state: e.set("elements", i) };
  }
}
class ct extends fe {
  constructor(n, t) {
    super(n);
    v(this, "_initialVector");
    this._initialVector = t;
  }
  _onUpdate(n, t, i) {
    const s = this._initialVector, r = _n(i, s);
    n.updateAngleRadian(t, r);
  }
}
class Pe extends fe {
  constructor(n, t) {
    super(n);
    v(this, "_initialVector");
    this._initialVector = t;
  }
  _onUpdate(n, t, i) {
    const s = this._initialVector, r = ee(i) / ee(s);
    n.updateScaleRatio(t, r);
  }
}
class Bs extends P {
  constructor(n, t) {
    super(n);
    v(this, "_borderColor");
    this._borderColor = t;
  }
  _execute(n) {
    n.setBorderColor(this._borderColor);
  }
}
class Fs extends P {
  constructor(n, t) {
    super(n);
    v(this, "_borderRadius");
    this._borderRadius = t;
  }
  _execute(n) {
    n.setBorderRadius(this._borderRadius);
  }
}
class Ls extends P {
  constructor(n, t) {
    super(n);
    v(this, "_borderWidth");
    this._borderWidth = t;
  }
  _execute(n) {
    n.setBorderWidth(this._borderWidth);
  }
}
class As extends P {
  constructor(n, t) {
    super(n);
    v(this, "_curvature");
    this._curvature = t;
  }
  _execute(n) {
    n.setCurvature(this._curvature);
  }
}
class Vs extends P {
  constructor(n, t) {
    super(n);
    v(this, "_stackGapRatio");
    this._stackGapRatio = t;
  }
  _execute(n) {
    n.setStackGapRatio(this._stackGapRatio);
  }
}
class Us extends P {
  constructor(n, t) {
    super(n);
    v(this, "_stackOffsetRatio");
    this._stackOffsetRatio = t;
  }
  _execute(n) {
    n.setStackOffsetRatio(this._stackOffsetRatio);
  }
}
class zs extends P {
  constructor(n, t) {
    super(n);
    v(this, "_numStackColumns");
    this._numStackColumns = t;
  }
  _execute(n) {
    n.setNumStackColumns(this._numStackColumns);
  }
}
class js extends P {
  constructor(n, t) {
    super(n);
    v(this, "_numStackRows");
    this._numStackRows = t;
  }
  _execute(n) {
    n.setNumStackRows(this._numStackRows);
  }
}
class Is {
  execute(e, n, t = F) {
    let i = e.background;
    if (i === null)
      throw new Error("There is no background");
    return i = t(
      i,
      (s) => {
        s.toggleVisibility();
      }
    ), { state: e.set("background", i) };
  }
}
class Ws extends P {
  constructor(e) {
    super(e);
  }
  _execute(e) {
    e.toggleLock();
  }
}
class Gs extends P {
  constructor(e) {
    super(e);
  }
  _execute(e) {
    e.toggleVisibility();
  }
}
class Co {
  constructor(e) {
    v(this, "_background");
    this._background = e;
  }
  execute(e) {
    return { state: e.set("background", this._background) };
  }
}
class Hs extends P {
  constructor(n, t) {
    super(n);
    v(this, "_targetArea");
    this._targetArea = t;
  }
  _execute(n) {
    n.verticallyCenterToPage(this._targetArea);
  }
}
class Eo {
  constructor(e, n) {
    v(this, "_backgroundRegistry");
    v(this, "_elementRegistry");
    this._backgroundRegistry = e, this._elementRegistry = n;
  }
  deserialize(e) {
    if (!(/* @__PURE__ */ (() => {
      const r = (l, c = !0) => typeof l.elements == "object" && l.elements !== null && Array.isArray(l.elements) === !1 && a(l.elements, c) && (Object.keys(l).length === 1 || Object.keys(l).every((m) => !!(["background", "elements"].some((u) => m === u) || l[m] === void 0))), a = (l, c = !0) => Object.keys(l).every((m) => (l[m] === void 0, !0));
      return (l, c = !0) => typeof l == "object" && l !== null && r(l, !0);
    })())(e))
      throw new Error("Data cannot be deserialized with DesignSerializer");
    const n = this._elementRegistry, t = Vt();
    for (const [r, a] of Object.entries(e.elements)) {
      const l = n.deserialize(a);
      t.set(r, l);
    }
    let i = null;
    const s = e.background;
    if (s !== void 0) {
      const r = this._backgroundRegistry.deserialize(s);
      i = r;
    }
    return Ut({
      background: i,
      elements: t
    });
  }
  serialize({ background: e, elements: n }) {
    const t = this._elementRegistry, i = {};
    for (const [r, a] of n)
      i[r] = t.serialize(a);
    let s;
    return e !== null && (s = this._backgroundRegistry.serialize(e)), {
      background: s,
      elements: i
    };
  }
}
class xo {
  constructor(e) {
    v(this, "_operatingToken");
    v(this, "_redoStates");
    v(this, "_state");
    v(this, "_undoStates");
    this._state = e ?? Ut(), this._undoStates = Be(), this._redoStates = Be();
  }
  get background() {
    return this._state.background;
  }
  get elements() {
    return this._state.elements;
  }
  get isEmpty() {
    const { background: e, elements: n } = this._state;
    return e === null && n.size === 0;
  }
  get isOperating() {
    return this._operatingToken !== void 0;
  }
  get isRedoable() {
    return this._redoStates.size > 0;
  }
  get isUndoable() {
    return this._undoStates.size > 0;
  }
  get state() {
    return this._state;
  }
  clear() {
    this.clearHistory(), this._state = this._state.clear();
  }
  clearHistory() {
    if (this._operatingToken !== void 0)
      throw new Error("Design cannot clear history in operating state");
    this._undoStates = this._undoStates.clear(), this._redoStates = this._redoStates.clear();
  }
  execute(e, n, { operatingToken: t, ignoreHistory: i } = {}) {
    if (t !== this._operatingToken)
      throw new Error("Design cannot execute commands in operating state");
    const s = this._state, r = e.execute(s, n);
    this._state = r.state, this._operatingToken = r.operatingToken, i !== !0 && (this._undoStates = this._undoStates.push(s), this._redoStates = this._redoStates.clear());
  }
  exportConfig(e) {
    return e.serialize(this._state);
  }
  importConfig(e, n) {
    this._state = n.deserialize(e), this._undoStates = this._undoStates.clear(), this._redoStates = this._redoStates.clear();
  }
  redo() {
    if (this._operatingToken !== void 0)
      throw new Error("Design cannot redo in operating state");
    const e = this._redoStates;
    if (e.isEmpty())
      throw new Error("Current design is not redoable");
    this._undoStates = this._undoStates.push(this._state), this._state = e.last(), this._redoStates = e.pop();
  }
  undo() {
    if (this._operatingToken !== void 0)
      throw new Error("Design cannot undo in operating state");
    const e = this._undoStates;
    if (e.isEmpty())
      throw new Error("Current design is not undoable");
    this._redoStates = this._redoStates.push(this._state), this._state = e.last(), this._undoStates = e.pop();
  }
}
function Mo(o) {
  return new xo(o);
}
const Po = /^\s*[Uu]\+([0-9A-Fa-f?]{1,6})(?:-([0-9A-Fa-f]{1,6}))?\s*$/;
var de;
class $o {
  constructor(e = "", n = []) {
    q(this, de);
    const t = e.split(",");
    for (const i of t) {
      const s = Po.exec(i);
      if (s !== null) {
        const r = Number.parseInt(s[1].replaceAll("?", "0"), 16), a = Number.parseInt(s[2] ?? s[1].replaceAll("?", "F"), 16);
        n.push([r, a]);
      }
    }
    n.length === 0 && n.push([0, 1114111]), J(this, de, n);
  }
  has(e) {
    for (const [n, t] of G(this, de))
      if (e >= n && e <= t)
        return !0;
    return !1;
  }
}
de = new WeakMap();
function jt(o) {
  return new $o(o);
}
async function Oo(o) {
  try {
    const { create: e } = await import("fontkit"), t = await (await fetch(o)).arrayBuffer();
    return e(new Uint8Array(t));
  } catch {
    return null;
  }
}
var ue, he, me;
class To {
  constructor({ src: e, unicodeRange: n }) {
    q(this, ue);
    q(this, he);
    q(this, me);
    J(this, he, e), n !== void 0 && J(this, me, n);
  }
  async getFont() {
    let e = G(this, ue);
    return e === void 0 && (e = Oo(G(this, he)), J(this, ue, e)), await e;
  }
  async getMetrics() {
    const e = await this.getFont(), { ascent: n, descent: t, lineGap: i, unitsPerEm: s } = e ?? {
      ascent: 0,
      descent: 0,
      lineGap: 0,
      unitsPerEm: 0
    };
    return { ascent: n, descent: t, lineGap: i, unitsPerEm: s };
  }
  async hasGlyphForCodePoint(e) {
    var t;
    if (!(((t = G(this, me)) == null ? void 0 : t.has(e)) ?? !0))
      return !1;
    const n = await this.getFont();
    return (n == null ? void 0 : n.hasGlyphForCodePoint(e)) ?? !1;
  }
  async layout(e, n) {
    const t = await this.getFont();
    if (t === null)
      return 0;
    const i = t.layout(e), s = i.positions;
    let r = 0, a = 0;
    for (const l of i.glyphs)
      a += l.advanceWidth, n.push({
        path: l.path,
        width: l.advanceWidth,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xAdvance: s[r++].xAdvance
      });
    return a;
  }
}
ue = new WeakMap(), he = new WeakMap(), me = new WeakMap();
var Q;
class Do {
  constructor(e) {
    q(this, Q);
    J(this, Q, e);
  }
  async getFontForCodePoint(e) {
    for (const n of G(this, Q))
      if (await n.hasGlyphForCodePoint(e))
        return n;
  }
  async getHighestPriorityFont() {
    for (const e of G(this, Q))
      if (await e.getFont() !== null)
        return e;
  }
  async hasGlyphForCodePoint(e) {
    return await this.getFontForCodePoint(e) !== void 0;
  }
  async textToPath(e, n, t) {
    let i = await this.getHighestPriorityFont();
    if (i === void 0)
      return {
        path: "",
        width: 0,
        height: 0,
        leading: 0
      };
    const { unitsPerEm: s, ascent: r, descent: a, lineGap: l } = await i.getMetrics(), c = n / s, m = (r - a + l) * c;
    let d = [];
    const u = [d];
    let y = 0, g = 0, f = 0, h = 0, w = 0;
    const p = e.length;
    for (; h < p; ) {
      let C = e.codePointAt(h);
      if (C === 10 && t > 0 && (C = 20), C === 10)
        i !== void 0 && (y += await i.layout(e.substring(w, h), d), i = void 0), ++f, d = [], u.push(d), g = Math.max(g, y), y = 0, w = ++h;
      else {
        const M = await this.getFontForCodePoint(C);
        M !== i && (i !== void 0 && (y += await i.layout(e.substring(w, h), d)), w = h, i = M), ++h;
      }
    }
    h > w && i !== void 0 && (y += await i.layout(e.substring(w, h), d), g = Math.max(g, y));
    const _ = [];
    if (t > 0) {
      const C = 2 * Math.PI * t / 100, M = g / C, T = u[0] ?? [], V = T[0], U = T[T.length - 1];
      if (V !== void 0 && U !== void 0) {
        const L = V.width, W = V.xAdvance, D = W - L / 2, Xe = C * (0.5 - D / g), Jt = U.width, Ke = U.xAdvance - Jt / 2, Ze = C * (Ke / g - 0.5), Z = M + r, qe = t < 50 ? Ke * Math.cos(Ze) - Z * Math.sin(Ze) + D * Math.cos(Xe) + Z * Math.sin(Xe) : Z * 2, Qt = Z - (t < 50 ? M * Math.cos(C / 2) + a : Math.min(Z * Math.cos(C / 2), a)), en = qe / 2;
        let Je = W - L;
        for (const { path: tn, xAdvance: nn, width: on } of T) {
          const Qe = on / 2, sn = Je + Qe, rn = Math.PI * (t - 2 * (sn * t) / g) / 100, an = tn.translate(-Qe, M).rotate(rn).translate(en, -Z).scale(c, -c).toSVG();
          _.push(an), Je += nn;
        }
        return {
          path: _.join(""),
          height: Qt * c,
          width: qe * c,
          leading: (r - s) * c
        };
      }
    } else {
      let C = r * c;
      for (const M of u) {
        let T = 0;
        for (const { path: V, xAdvance: U } of M) {
          const L = V.scale(c, -c).translate(T, C).toSVG();
          _.push(L), T += U * c;
        }
        C += n;
      }
    }
    return {
      path: _.join(""),
      height: m + f * n,
      width: g * c,
      leading: (r - s) * c
    };
  }
}
Q = new WeakMap();
const It = Symbol("font-util symbol");
function Wt() {
  const o = we(It);
  if (o === void 0)
    throw new Error("There is no fontUtil provided");
  const { fallbackFonts: e, fontSourceMap: n } = o;
  async function t() {
    const l = await n(), c = /* @__PURE__ */ new Map();
    for (const [m, d] of l) {
      const u = [];
      for (const y of d)
        u.push(new To(y));
      c.set(m, u);
    }
    return c;
  }
  const i = t();
  async function s(l) {
    const c = await i, m = [];
    let d = c.get(l);
    d !== void 0 && m.push(...d);
    for (const u of e)
      d = c.get(u), d !== void 0 && m.push(...d);
    return new Do(m);
  }
  async function r(l, c) {
    if (!(await i).has(c))
      throw new Error(`Font ${c} is not a design font`);
    const d = new Set(l);
    d.delete(`
`);
    const u = [], y = await s(c);
    for (const f of d) {
      const h = f.codePointAt(0);
      await y.hasGlyphForCodePoint(h) || u.push(f);
    }
    const g = l.replaceAll(new RegExp(`[${u.join("")}]`, "gu"), "");
    return {
      errorCharList: u,
      validText: g
    };
  }
  async function a(l, c, m, d) {
    return await (await s(c)).textToPath(l, m, d);
  }
  return {
    fallbackFonts: e,
    // 此字型大小是大部分字型在手機殼尺寸不會印壞的大小
    fontSizeUnit: 28,
    checkContent: r,
    textToPath: a
  };
}
function Gt(o) {
  const e = I({ x: 0, y: 0, width: 0, height: 0 });
  function n() {
    var r;
    e.value = ((r = o.value) == null ? void 0 : r.getBoundingClientRect()) ?? e.value;
  }
  window.addEventListener("resize", n), window.addEventListener("scroll", n);
  const t = new MutationObserver(n), i = new ResizeObserver(n), s = N(o, (r) => {
    r !== null && (i.disconnect(), i.observe(r), t.disconnect(), t.observe(r, { attributeFilter: ["style", "class"] }));
  });
  return ge(() => {
    window.removeEventListener("resize", n), window.removeEventListener("scroll", n), s(), i.disconnect(), t.disconnect();
  }), e;
}
const Ht = Symbol("layout symbol");
function Nt() {
  const o = we(Ht);
  if (o === void 0)
    throw new Error("There is no layout provided");
  return o;
}
const Yt = Symbol("design storage symbol");
function Bo(o) {
  return Mo(o);
}
function Fo(o, {
  createImmutableDesign: e = Bo,
  cloneMutate: n = F
} = {}) {
  let t;
  const i = we(Yt);
  if (i === void 0)
    throw new Error("There is no storage for persistent design");
  {
    const l = i.load();
    if (l !== null)
      try {
        const c = JSON.parse(l);
        t = o.deserialize(c);
      } catch (c) {
        console.warn(c);
      }
  }
  const s = e(t), r = I(s);
  N(
    () => r.value,
    yn(() => {
      const l = r.value.exportConfig(o);
      i.save(JSON.stringify(l));
    }, 100)
  );
  function a(l) {
    r.value = n(r.value, l);
  }
  return [r, a];
}
function Ee(o, e) {
  let n = null;
  const t = o.register((c) => {
    n === null && (n = c, e.onPointerMove !== void 0 && (window.addEventListener("touchstart", s, { passive: !0 }), window.addEventListener("pointermove", r, { passive: !0 }), window.addEventListener("pointerup", l, { passive: !0 })), e.onTwoPointerGesture !== void 0 && (window.addEventListener("touchmove", a, { passive: !0 }), window.addEventListener("touchend", l, { passive: !0 })));
  });
  function i() {
    window.removeEventListener("touchstart", s), window.removeEventListener("pointermove", r), window.removeEventListener("pointerup", l), window.removeEventListener("touchmove", a), window.removeEventListener("touchend", l);
  }
  function s(c) {
    c.touches.length > 1 && (n == null || n.done(), n = null);
  }
  function r(c) {
    var m;
    if (n !== null) {
      const d = (m = e.onPointerMove) == null ? void 0 : m.call(void 0, {
        x: c.clientX,
        y: c.clientY
      });
      d !== void 0 && (n.update(...d), c.stopPropagation());
    }
  }
  function a(c) {
    var m;
    if (n !== null) {
      const [d, u] = c.touches;
      if (d === void 0 || u === void 0)
        return;
      const y = (m = e.onTwoPointerGesture) == null ? void 0 : m.call(
        void 0,
        { x: d.clientX, y: d.clientY },
        { x: u.clientX, y: u.clientY }
      );
      y !== void 0 && (n.update(...y), c.stopPropagation());
    }
  }
  function l(c) {
    n !== null && (n.done(), n = null, i(), c.stopPropagation());
  }
  ge(() => {
    i(), t();
  });
}
const Ge = Symbol("view-box source symbol");
function X() {
  const o = we(Ge);
  if (o === void 0)
    throw new Error("There is no viewBox provided");
  const { viewBoxSize: e, containerRect: n } = o, t = x(
    () => n.value.height > 0 ? e.value / n.value.height : 0
  );
  function i(r) {
    return ze(j(r, n.value), t.value);
  }
  function s(r) {
    const a = t.value, { x: l, y: c } = n.value;
    return {
      x: r.x / a + l,
      y: r.y / a + c,
      width: r.width / a,
      height: r.height / a
    };
  }
  return {
    ratioRef: t,
    screenToViewBox: i,
    viewBoxToScreen: s
  };
}
const K = vn("designStore", () => {
  const o = new Eo(le, A), [e, n] = Fo(o), t = I(null), i = x(
    () => t.value === null ? null : e.value.elements.get(t.value) ?? null
  );
  function s(p) {
    const _ = new Co(p);
    m(_);
  }
  function r(p) {
    const _ = i.value;
    (_ == null ? void 0 : _.isOperating) !== !0 && (t.value = p);
  }
  function a(p) {
    const _ = new wo(p);
    m(_), r(_.elementId ?? null);
  }
  function l(p) {
    const _ = new Ro(p);
    m(_), r(null);
  }
  function c(p, _) {
    const C = new So(p, _);
    m(C);
  }
  function m(p, _) {
    n((C) => {
      C.execute(p, m, _);
    });
  }
  function d() {
    n((p) => {
      p.undo();
    }), r(null);
  }
  function u() {
    n((p) => {
      p.redo();
    }), r(null);
  }
  function y() {
    n((p) => {
      p.clearHistory();
    });
  }
  function g() {
    const p = new bo();
    m(p);
  }
  function f() {
    n((p) => {
      p.clear();
    }), r(null);
  }
  function h(p) {
    n((_) => {
      _.importConfig(p, o);
    }), r(null);
  }
  function w() {
    return e.value.exportConfig(o);
  }
  return {
    design: e,
    selectedElementId: t,
    selectedElement: i,
    updateBackground: s,
    selectElement: r,
    appendElement: a,
    removeElement: l,
    reorderElement: c,
    execute: m,
    undo: d,
    redo: u,
    clearHistory: y,
    clearDesign: g,
    clear: f,
    importConfig: h,
    exportConfig: w
  };
}), Lo = ["height", "href", "transform", "visibility", "width"], Ao = ["fill", "height", "visibility", "width"], Vo = /* @__PURE__ */ O({
  __name: "DesignBackground",
  props: {
    background: {}
  },
  setup(o) {
    return (e, n) => (b(), k(z, null, [
      S(Cn)(e.background) ? (b(), k("image", {
        key: 0,
        height: e.background.height,
        href: e.background.imageUrl,
        transform: `translate(${e.background.position.x} ${e.background.position.y})`,
        visibility: e.background.isVisible ? "visible" : "hidden",
        width: e.background.width,
        "data-amuse-design-canvas-artwork-element": ""
      }, null, 8, Lo)) : E("", !0),
      S(Pn)(e.background) ? (b(), k("rect", {
        key: 1,
        fill: e.background.colorCode,
        height: e.background.height,
        visibility: e.background.isVisible ? "visible" : "hidden",
        width: e.background.width
      }, null, 8, Ao)) : E("", !0)
    ], 64));
  }
}), Uo = ["id", "height", "href", "transform", "visibility", "width"], zo = /* @__PURE__ */ O({
  __name: "BarcodeElement",
  props: {
    element: {},
    id: {}
  },
  emits: ["select"],
  setup(o) {
    return (e, n) => (b(), k("image", {
      id: e.id,
      height: e.element.height,
      href: e.element.imageUrl,
      transform: `translate(${e.element.position.x} ${e.element.position.y}) rotate(${e.element.angleRadian * 180 / Math.PI})`,
      visibility: e.element.isVisible ? "visible" : "hidden",
      width: e.element.width,
      onClickPassive: n[0] || (n[0] = B((t) => e.$emit("select"), ["stop"]))
    }, null, 40, Uo));
  }
}), jo = ["id", "transform", "visibility"], Io = ["id", "height", "rx", "width"], Wo = ["id"], Go = ["href"], Ho = ["clip-path", "height", "href", "mask", "width", "x", "y"], No = ["href", "stroke", "stroke-width"], Yo = /* @__PURE__ */ O({
  __name: "PhotoElement",
  props: {
    element: {},
    id: {}
  },
  emits: ["select"],
  setup(o) {
    return (e, n) => (b(), k("g", {
      id: e.id,
      transform: `translate(${e.element.position.x} ${e.element.position.y}) scale(${e.element.scaleRatio}) rotate(${e.element.angleRadian * 180 / Math.PI})${e.element.isMirrored ? ` translate(${e.element.originWidth - e.element.clipLeft - e.element.clipRight} 0) scale(-1 1)` : ""}`,
      visibility: e.element.isVisible ? "visible" : "hidden",
      onClickPassive: n[0] || (n[0] = B((t) => e.$emit("select"), ["stop"]))
    }, [
      R("defs", null, [
        R("rect", {
          id: `${e.id}-rect`,
          height: e.element.originHeight - e.element.clipTop - e.element.clipBottom,
          rx: `${e.element.borderRadius}%`,
          width: e.element.originWidth - e.element.clipLeft - e.element.clipRight
        }, null, 8, Io),
        R("mask", {
          id: `${e.id}-mask`
        }, [
          R("use", {
            fill: "#FFFFFF",
            href: `#${e.id}-rect`
          }, null, 8, Go)
        ], 8, Wo)
      ]),
      R("image", {
        "clip-path": e.element.isMirrored ? `inset(${e.element.clipTop} ${e.element.clipLeft} ${e.element.clipBottom} ${e.element.clipRight})` : `inset(${e.element.clipTop} ${e.element.clipRight} ${e.element.clipBottom} ${e.element.clipLeft})`,
        height: e.element.originHeight,
        href: e.element.imageUrl,
        mask: `url(#${e.id}-mask)`,
        width: e.element.originWidth,
        x: e.element.isMirrored ? -e.element.clipRight : -e.element.clipLeft,
        y: -e.element.clipTop
      }, null, 8, Ho),
      e.element.borderWidth > 0 && e.element.borderColor !== void 0 ? (b(), k("use", {
        key: 0,
        fill: "none",
        href: `#${e.id}-rect`,
        stroke: e.element.borderColor,
        "stroke-width": e.element.borderWidth / e.element.scaleRatio
      }, null, 8, No)) : E("", !0)
    ], 40, jo));
  }
}), Xo = ["id", "clip-path", "transform", "visibility"], Ko = ["id"], Zo = ["height", "width"], qo = ["transform"], Jo = ["id", "height", "href", "width"], Qo = ["href", "x", "y"], ei = ["href", "x", "y"], ti = ["href", "x", "y"], ni = /* @__PURE__ */ O({
  __name: "StickerElement",
  props: {
    element: {},
    id: {}
  },
  emits: ["select"],
  setup(o) {
    return (e, n) => (b(), k("g", {
      id: e.id,
      "clip-path": `url(#${e.id}-clip)`,
      "data-amuse-design-canvas-artwork-element": "",
      transform: `translate(${e.element.position.x} ${e.element.position.y}) rotate(${e.element.angleRadian * 180 / Math.PI})`,
      visibility: e.element.isVisible ? "visible" : "hidden",
      onClickPassive: n[0] || (n[0] = B((t) => e.$emit("select"), ["stop"]))
    }, [
      R("clipPath", {
        id: `${e.id}-clip`
      }, [
        R("rect", {
          height: e.element.height,
          width: e.element.width
        }, null, 8, Zo)
      ], 8, Ko),
      R("g", {
        transform: `scale(${e.element.scaleRatio})`
      }, [
        R("image", {
          id: `${e.id}-image`,
          height: e.element.originHeight,
          href: e.element.imageUrl,
          width: e.element.originWidth
        }, null, 8, Jo),
        (b(!0), k(z, null, re(e.element.numStackRows, (t) => (b(), k(z, { key: t }, [
          t % 2 === 0 ? (b(), k("use", {
            key: 0,
            href: `#${e.id}-image`,
            x: e.element.stackOffset - (e.element.originWidth + e.element.stackGap),
            y: (e.element.originHeight + e.element.stackGap) * (t - 1)
          }, null, 8, Qo)) : E("", !0),
          (b(!0), k(z, null, re(e.element.numStackColumns, (i) => (b(), k("use", {
            key: i,
            href: `#${e.id}-image`,
            x: (e.element.originWidth + e.element.stackGap) * (i - 1) + e.element.stackOffset * ((t - 1) % 2),
            y: (e.element.originHeight + e.element.stackGap) * (t - 1)
          }, null, 8, ei))), 128)),
          t % 2 === 0 ? (b(), k("use", {
            key: 1,
            href: `#${e.id}-image`,
            x: (e.element.originWidth + e.element.stackGap) * e.element.numStackColumns + e.element.stackOffset,
            y: (e.element.originHeight + e.element.stackGap) * (t - 1)
          }, null, 8, ti)) : E("", !0)
        ], 64))), 128))
      ], 8, qo)
    ], 40, Xo));
  }
});
function oi(o) {
  return o * 0.75;
}
function ii(o) {
  return o * 4 / 3;
}
const si = ["id", "visibility"], ri = ["fill", "height", "rx", "ry", "transform", "width"], ai = ["d", "fill", "transform"], li = /* @__PURE__ */ O({
  __name: "TextElement",
  props: {
    element: {},
    id: {}
  },
  emits: ["select"],
  setup(o) {
    const e = o, { fontSizeUnit: n, textToPath: t } = Wt(), i = I({ x: 0, y: 0, width: 0, height: 0 });
    N(
      () => e.element,
      (r) => {
        r.setBoxSizeGetter(() => i.value);
      },
      {
        immediate: !0
      }
    );
    const s = I("");
    return N(
      () => e.element,
      async (r) => {
        const { path: a, width: l, height: c, leading: m } = await t(
          r.content,
          r.fontFamily,
          ii(n),
          r.isContentEditing ? 0 : r.curvature
        );
        r === e.element && (s.value = a, i.value = {
          x: 0,
          y: m,
          width: l + 2 * r.backgroundPadding,
          height: c + 2 * r.backgroundPadding
        });
      },
      { immediate: !0 }
    ), (r, a) => (b(), k("g", {
      id: r.id,
      visibility: r.element.isVisible ? "visible" : "hidden",
      onClickPassive: a[0] || (a[0] = B((l) => r.$emit("select"), ["stop"]))
    }, [
      R("rect", {
        "data-amuse-testid": "text-background",
        fill: r.element.backgroundColor ?? "transparent",
        height: r.element.height,
        rx: `${r.element.backgroundRadius / 100 * r.element.width}`,
        ry: `${r.element.backgroundRadius / 100 * r.element.height}`,
        transform: `translate(${r.element.position.x} ${r.element.position.y}) rotate(${r.element.angleRadian * 180 / Math.PI})`,
        width: r.element.width
      }, null, 8, ri),
      R("path", {
        d: s.value,
        "data-amuse-testid": "text-path",
        fill: r.element.color,
        transform: `translate(${r.element.position.x} ${r.element.position.y}) scale(${r.element.scaleRatio}) rotate(${r.element.angleRadian * 180 / Math.PI}) translate(${r.element.backgroundPadding} ${r.element.backgroundPadding})`
      }, null, 8, ai)
    ], 40, si));
  }
}), ci = /* @__PURE__ */ O({
  __name: "DesignElement",
  props: {
    element: {},
    id: {}
  },
  emits: ["select"],
  setup(o, { emit: e }) {
    const n = o, t = e;
    function i() {
      n.element.isLocked || t("select");
    }
    return (s, r) => (b(), k(z, null, [
      S(io)(s.element) ? (b(), $(Yo, {
        key: 0,
        id: s.id,
        element: s.element,
        onSelect: i
      }, null, 8, ["id", "element"])) : E("", !0),
      S(po)(s.element) ? (b(), $(li, {
        key: 1,
        id: s.id,
        element: s.element,
        onSelect: i
      }, null, 8, ["id", "element"])) : E("", !0),
      S(lo)(s.element) ? (b(), $(ni, {
        key: 2,
        id: s.id,
        element: s.element,
        onSelect: i
      }, null, 8, ["id", "element"])) : E("", !0),
      S(Gn)(s.element) ? (b(), $(zo, {
        key: 3,
        id: s.id,
        element: s.element,
        onSelect: i
      }, null, 8, ["id", "element"])) : E("", !0)
    ], 64));
  }
}), di = ["viewBox"], ui = { "data-amuse-design-canvas-layer": "pre-design" }, hi = ["height", "href", "width"], mi = ["height", "width", "x", "y"], gi = ["height", "href", "width", "x", "y"], fi = ["href"], pi = ["height", "mask", "viewBox", "width", "x", "y"], yi = ["fill", "height", "width"], vi = {
  key: 1,
  class: "pointer-events-none",
  "data-amuse-design-canvas-layer": "post-design"
}, $e = "preview-mask", Oe = "print-mask", Te = "http://www.w3.org/2000/svg", wi = /* @__PURE__ */ O({
  __name: "DesignSvg",
  props: {
    design: {},
    designRect: {},
    maskMode: { default: "basic" },
    previewMaskUrl: {},
    printMaskUrl: {},
    selectedElementId: { default: null },
    showPrintAreaWarning: { type: Boolean, default: !1 },
    viewBoxSize: {}
  },
  emits: ["select"],
  setup(o, { expose: e, emit: n }) {
    const t = o, i = n, s = Y("containerEl"), r = Y("designEl"), a = Gt(s), l = /^inset\(([\d.]+) ([\d.]+) ([\d.]+) ([\d.]+)\)$/;
    function c() {
      var y;
      const u = (y = s.value) == null ? void 0 : y.cloneNode(!0);
      if (!(u instanceof SVGSVGElement))
        throw new TypeError("Cloned design SVG is not a SVG element");
      return u;
    }
    function m() {
      var y;
      const u = (y = r.value) == null ? void 0 : y.cloneNode(!0);
      if (!(u instanceof SVGSVGElement))
        throw new TypeError("Cloned design SVG is not a SVG element");
      return u.removeAttribute("mask"), u;
    }
    function d({ onlyDesign: u = !1, excludeArtwork: y = !1 }) {
      var w;
      const g = u ? m() : c();
      g.setAttribute("visibility", "hidden"), document.body.append(g), y && g.querySelectorAll("[data-amuse-design-canvas-artwork-element]").forEach((p) => {
        p.remove();
      });
      const f = g.querySelectorAll("image[clip-path]"), h = document.createElementNS(Te, "defs");
      for (const p of f) {
        const _ = ((w = p.getAttribute("clip-path")) == null ? void 0 : w.match(l)) ?? null;
        if (_ === null)
          continue;
        const C = Number(_[1]), M = Number(_[2]), T = Number(_[3]), V = Number(_[4]), U = Ue();
        p.setAttribute("clip-path", `url(#${U})`);
        const L = document.createElementNS(Te, "clipPath");
        L.id = U;
        const W = document.createElementNS(Te, "rect");
        W.setAttribute("width", `${p.width.baseVal.value - M - V}`), W.setAttribute("height", `${p.height.baseVal.value - C - T}`), L.appendChild(W), h.appendChild(L);
      }
      return g.appendChild(h), g.remove(), g.removeAttribute("visibility"), g.removeAttribute("style"), g;
    }
    return De(Ge, {
      viewBoxSize: x(() => t.viewBoxSize),
      containerRect: a
    }), e({ containerRect: a, exportDom: d }), (u, y) => (b(), k("svg", {
      ref_key: "containerEl",
      ref: s,
      viewBox: `0 0 ${u.viewBoxSize} ${u.viewBoxSize}`,
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      R("g", ui, [
        se(u.$slots, "pre-design")
      ]),
      R("mask", {
        id: $e,
        "data-amuse-design-canvas-layer": $e
      }, [
        u.maskMode === "basic" ? (b(), k("image", {
          key: 0,
          height: u.viewBoxSize,
          href: u.previewMaskUrl,
          width: u.viewBoxSize,
          x: 0,
          y: 0
        }, null, 8, hi)) : u.maskMode === "designRect" ? (b(), k("rect", {
          key: 1,
          fill: "#fff",
          height: u.designRect.height,
          width: u.designRect.width,
          x: u.designRect.x,
          y: u.designRect.y
        }, null, 8, mi)) : E("", !0)
      ]),
      R("mask", {
        id: Oe,
        "data-amuse-design-canvas-layer": Oe
      }, [
        R("image", {
          height: u.designRect.height,
          href: u.printMaskUrl,
          width: u.designRect.width,
          x: u.designRect.x,
          y: u.designRect.y
        }, null, 8, gi)
      ]),
      u.selectedElementId ? (b(), k("use", {
        key: 0,
        href: `#${u.selectedElementId}`,
        opacity: "0.2"
      }, null, 8, fi)) : E("", !0),
      (b(), k("svg", {
        ref_key: "designEl",
        ref: r,
        "data-amuse-design-canvas-layer": "design",
        height: u.designRect.height,
        mask: `url('#${u.showPrintAreaWarning ? Oe : $e}')`,
        viewBox: `${u.designRect.x} ${u.designRect.y} ${u.designRect.width} ${u.designRect.height}`,
        width: u.designRect.width,
        x: u.designRect.x,
        xmlns: "http://www.w3.org/2000/svg",
        y: u.designRect.y
      }, [
        u.design.background !== null ? (b(), $(Vo, {
          key: 0,
          background: u.design.background
        }, null, 8, ["background"])) : E("", !0),
        u.showPrintAreaWarning ? (b(), k("rect", {
          key: 1,
          fill: S(ae).brand.deepYellow,
          height: u.viewBoxSize,
          opacity: "0.6",
          width: u.viewBoxSize
        }, null, 8, yi)) : E("", !0),
        (b(!0), k(z, null, re(u.design.elements, ([g, f]) => (b(), $(ci, {
          id: g,
          key: g,
          element: f,
          onSelect: (h) => i("select", g)
        }, null, 8, ["id", "element", "onSelect"]))), 128))
      ], 8, pi)),
      u.showPrintAreaWarning ? E("", !0) : (b(), k("g", vi, [
        se(u.$slots, "post-design")
      ])),
      se(u.$slots, "design-handle")
    ], 8, di));
  }
}), bi = ["height", "rx", "stroke-width", "width", "x", "y"], _i = ["height", "rx", "stroke-width", "width", "x", "y"], ki = ["height", "rx", "stroke-width", "width", "x", "y"], Ri = ["height", "rx", "stroke-width", "width", "x", "y"], Si = /* @__PURE__ */ O({
  __name: "CropHandle",
  props: {
    element: {}
  },
  setup(o) {
    const e = o, { ratioRef: n, screenToViewBox: t } = X(), i = x(() => 30 * n.value), s = x(() => 3 * n.value), r = x(() => `${15 * n.value}px`);
    Ee(H, {
      onPointerMove: (c) => [t(c)]
    });
    const a = K();
    function l(c, m) {
      const d = H.create(e.element, t(c), m);
      a.execute(d);
    }
    return (c, m) => (b(), k("g", null, [
      R("rect", {
        class: "cursor-row-resize",
        height: s.value,
        rx: s.value / 2,
        "stroke-width": r.value,
        width: i.value,
        x: (c.element.width - i.value) / 2,
        y: -s.value / 2,
        onPointerdownPassive: m[0] || (m[0] = (d) => l(d, "top"))
      }, null, 40, bi),
      R("rect", {
        class: "cursor-row-resize",
        height: s.value,
        rx: s.value / 2,
        "stroke-width": r.value,
        width: i.value,
        x: (c.element.width - i.value) / 2,
        y: c.element.height - s.value / 2,
        onPointerdownPassive: m[1] || (m[1] = (d) => l(d, "bottom"))
      }, null, 40, _i),
      R("rect", {
        class: "cursor-col-resize",
        height: i.value,
        rx: s.value / 2,
        "stroke-width": r.value,
        width: s.value,
        x: -s.value / 2,
        y: (c.element.height - i.value) / 2,
        onPointerdownPassive: m[2] || (m[2] = (d) => l(d, "left"))
      }, null, 40, ki),
      R("rect", {
        class: "cursor-col-resize",
        height: i.value,
        rx: s.value / 2,
        "stroke-width": r.value,
        width: s.value,
        x: c.element.width - s.value / 2,
        y: (c.element.height - i.value) / 2,
        onPointerdownPassive: m[3] || (m[3] = (d) => l(d, "right"))
      }, null, 40, Ri)
    ]));
  }
}), He = (o, e) => {
  const n = o.__vccOpts || o;
  for (const [t, i] of e)
    n[t] = i;
  return n;
}, Ci = /* @__PURE__ */ He(Si, [["__scopeId", "data-v-6fb1771b"]]), Ei = ["height", "width"], xi = ["stroke", "stroke-width", "x1", "x2", "y1", "y2"], Mi = ["stroke", "stroke-width", "x1", "x2", "y1", "y2"], Pi = /* @__PURE__ */ O({
  __name: "MoveHandle",
  props: {
    element: {}
  },
  setup(o) {
    const e = o, n = K(), { screenToViewBox: t } = X();
    Ee(lt, {
      onPointerMove: (c) => [t(c)]
    });
    const i = I({
      x: [],
      y: []
    }), { displayAnchorId: s } = Nt(), { ratioRef: r } = X(), a = x(() => `${r.value}px`);
    function l(c) {
      const m = new lt(e.element, t(c), (d) => {
        i.value = d;
      });
      n.execute(m);
    }
    return (c, m) => (b(), k(z, null, [
      R("rect", {
        class: "cursor-move",
        "fill-opacity": "0",
        height: c.element.height,
        width: c.element.width,
        onPointerdownPassive: l
      }, null, 40, Ei),
      (b(), $(ht, {
        to: `#${S(s)}`
      }, [
        (b(!0), k(z, null, re(i.value.x, ({ value: d, start: u, end: y }) => (b(), k("line", {
          key: d,
          stroke: S(ae).orange,
          "stroke-width": a.value,
          x1: d,
          x2: d,
          y1: u,
          y2: y
        }, null, 8, xi))), 128)),
        (b(!0), k(z, null, re(i.value.y, ({ value: d, start: u, end: y }) => (b(), k("line", {
          key: d,
          stroke: S(ae).orange,
          "stroke-width": a.value,
          x1: u,
          x2: y,
          y1: d,
          y2: d
        }, null, 8, Mi))), 128))
      ], 8, ["to"]))
    ], 64));
  }
}), $i = ["transform"], Oi = { key: 0 }, Ti = ["fill", "height", "rx", "width", "x", "y"], Di = ["fill", "font-size", "x", "y"], Bi = 13, Fi = /* @__PURE__ */ O({
  __name: "RotateHandle",
  props: {
    element: {}
  },
  setup(o) {
    const e = o, { ratioRef: n, screenToViewBox: t } = X(), i = x(() => 1.5 * n.value), s = x(() => Bi * i.value);
    Ee(ct, {
      onPointerMove: (h) => {
        const w = e.element;
        return [j(t(h), te(w.position, w.centerPosition))];
      }
    });
    const r = K();
    function a(h) {
      const w = e.element, p = new ct(
        e.element,
        j(t(h), te(w.position, w.centerPosition))
      );
      r.execute(p);
    }
    const { displayAnchorId: l } = Nt(), c = x(() => Math.round(e.element.angleRadian * 180 / Math.PI)), m = x(() => 24 * n.value), d = x(() => {
      const { width: h, x: w, y: p } = e.element.boundingRect;
      return { x: w + h / 2, y: p - 30 * n.value };
    }), u = Y("el"), y = I({ x: 0, y: 0, width: 0, height: 0 });
    function g() {
      var M;
      const { x: h, y: w, width: p, height: _ } = ((M = u.value) == null ? void 0 : M.getBBox()) ?? { x: 0, y: 0, width: 0, height: 0 }, C = 5 * n.value;
      y.value = {
        x: h - C,
        y: w - C,
        width: p + 2 * C,
        height: _ + 2 * C
      };
    }
    const f = N(() => e.element, g);
    return mt(g), ge(f), (h, w) => (b(), k(z, null, [
      R("g", {
        transform: `translate(${h.element.width - s.value}, ${h.element.height - s.value}) scale(${i.value})`,
        onPointerdownPassive: a
      }, w[0] || (w[0] = [
        R("circle", {
          class: "cursor-pointer drop-shadow-md",
          cx: "13",
          cy: "13",
          fill: "white",
          r: "10"
        }, null, -1),
        R("path", {
          d: "M13.038 17.6667C15.6154 17.6667 17.7047 15.5773 17.7047 13C17.7047 10.4227 15.6154 8.33335 13.038 8.33335C10.7365 8.33335 8.82408 9.99949 8.44117 12.1914L9.52544 11.5654C9.68488 11.4734 9.88874 11.528 9.98079 11.6874C10.0728 11.8468 10.0182 12.0507 9.85878 12.1428L8.12673 13.1428C7.9673 13.2348 7.76343 13.1802 7.67138 13.0207L6.67138 11.2887C6.57934 11.1293 6.63396 10.9254 6.79339 10.8334C6.95282 10.7413 7.15669 10.7959 7.24873 10.9554L7.81191 11.9308C8.30705 9.49769 10.4587 7.66669 13.038 7.66669C15.9836 7.66669 18.3714 10.0545 18.3714 13C18.3714 15.9455 15.9836 18.3334 13.038 18.3334C11.2814 18.3334 9.72309 17.4841 8.75135 16.1737C8.59074 15.9571 8.75555 15.6667 9.02518 15.6667C9.13963 15.6667 9.24614 15.7232 9.31523 15.8144C10.1673 16.9397 11.5178 17.6667 13.038 17.6667Z",
          fill: "#5F6858"
        }, null, -1)
      ]), 40, $i),
      (b(), $(ht, {
        to: `#${S(l)}`
      }, [
        h.element.isRotating ? (b(), k("g", Oi, [
          R("rect", {
            fill: S(ae).primary[100],
            "fill-opacity": "80%",
            height: y.value.height,
            rx: 15 * S(n),
            width: y.value.width,
            x: y.value.x,
            y: y.value.y
          }, null, 8, Ti),
          R("text", {
            ref_key: "el",
            ref: u,
            "dominant-baseline": "middle",
            fill: S(ae).white,
            "font-size": m.value,
            "text-anchor": "middle",
            x: d.value.x,
            y: d.value.y
          }, dn(c.value) + "°", 9, Di)
        ])) : E("", !0)
      ], 8, ["to"]))
    ], 64));
  }
});
async function Ne(o) {
  return await new Promise((e) => window.setTimeout(e, o));
}
const Li = ["r", "stroke-width"], Ai = ["cx", "r", "stroke-width"], Vi = ["cy", "r", "stroke-width"], Ui = /* @__PURE__ */ O({
  __name: "ScaleHandle",
  props: {
    element: {}
  },
  setup(o) {
    const e = o, { ratioRef: n, screenToViewBox: t } = X(), i = x(() => `${7 * n.value}px`), s = x(() => `${10 * n.value}`), r = [
      "cursor-nwse-resize",
      "cursor-ns-resize",
      "cursor-nesw-resize",
      "cursor-ew-resize"
    ], a = x(
      () => (Math.round(e.element.angleRadian * 180 / Math.PI / 45) + r.length) % r.length
    );
    Ee(Pe, {
      onPointerMove: (d) => {
        const u = e.element;
        return [j(t(d), te(u.position, u.centerPosition))];
      },
      onTwoPointerGesture: (d, u) => [j(d, u)]
    });
    const l = K();
    function c(d) {
      const u = e.element, y = new Pe(
        e.element,
        j(t(d), te(u.position, u.centerPosition))
      );
      l.execute(y);
    }
    async function m(d) {
      await Ne();
      const u = d.touches;
      if (!e.element.isOperating && u.length === 2) {
        const [y, g] = u;
        if (y === void 0 || g === void 0)
          return;
        const f = new Pe(e.element, {
          x: y.clientX - g.clientX,
          y: y.clientY - g.clientY
        });
        l.execute(f);
      }
    }
    return mt(() => {
      window.addEventListener("touchstart", m);
    }), ge(() => {
      window.removeEventListener("touchstart", m);
    }), (d, u) => (b(), k("g", { onPointerdownPassive: c }, [
      R("circle", {
        class: xe(r[a.value]),
        r: i.value,
        "stroke-width": s.value
      }, null, 10, Li),
      R("circle", {
        class: xe(r[(a.value + 2) % r.length]),
        cx: d.element.width,
        r: i.value,
        "stroke-width": s.value
      }, null, 10, Ai),
      R("circle", {
        class: xe(r[(a.value + 2) % r.length]),
        cy: d.element.height,
        r: i.value,
        "stroke-width": s.value
      }, null, 10, Vi)
    ], 32));
  }
}), zi = /* @__PURE__ */ He(Ui, [["__scopeId", "data-v-f8eebc58"]]), ji = ["height", "width"], Ii = ["readonly"], Wi = /* @__PURE__ */ O({
  __name: "TextContentEditor",
  props: {
    element: {}
  },
  emits: ["end", "rejectTextContent", "start"],
  setup(o, { emit: e }) {
    const n = o, t = e, { checkContent: i, fallbackFonts: s, fontSizeUnit: r } = Wt();
    let a = null;
    const l = zt.register((h) => {
      a = h;
    }), c = I(n.element.content), m = Y("el");
    N(m, () => {
      m.value !== null && (m.value.focus({ preventScroll: !0 }), t("start"));
    });
    let d;
    async function u() {
      if (a === null) return;
      c.value = c.value.replaceAll(/[\uFE00-\uFE0F]/g, "");
      const h = c.value;
      a.update(h);
      const w = i(h, n.element.fontFamily);
      d = Promise.all([
        w,
        // 為了讓視覺上呈現出輸入文字後才被刪掉的，至少 delay 100 ms 再呈現檢查結果
        Ne(100)
      ]);
      const [p] = await d;
      h === c.value && (p.errorCharList.length > 0 && t("rejectTextContent", p.errorCharList), a.update(p.validText), c.value = p.validText);
    }
    const y = I(!1);
    async function g() {
      a !== null && (y.value = !0, await d, a.done(), a = null, t("end"), y.value = !1);
    }
    ge(() => {
      g(), l();
    });
    const f = x(() => oi(n.element.backgroundPadding));
    return (h, w) => h.element.isContentEditing ? (b(), k("foreignObject", {
      key: 0,
      height: h.element.height,
      width: h.element.width
    }, [
      un(R("textarea", {
        ref_key: "el",
        ref: m,
        "onUpdate:modelValue": w[0] || (w[0] = (p) => c.value = p),
        class: "box-border scrollbar-hide h-full w-full resize-none whitespace-pre border-none bg-transparent leading-none outline-none",
        readonly: y.value,
        style: be({
          "font-size": `${S(r) * h.element.scaleRatio}pt`,
          color: h.element.color,
          "background-color": h.element.backgroundColor,
          paddingTop: `${(f.value + h.element.leading) * h.element.scaleRatio}pt`,
          paddingLeft: `${f.value * h.element.scaleRatio}pt`,
          "font-family": `${h.element.fontFamily},${S(s).join(",")}`
        }),
        onBlurPassive: g,
        onInputPassive: u
      }, null, 44, Ii), [
        [hn, c.value]
      ])
    ], 8, ji)) : E("", !0);
  }
}), Gi = ["transform"], Hi = ["height", "stroke-width", "width"], Ni = /* @__PURE__ */ O({
  __name: "OperateHandle",
  props: {
    element: {}
  },
  emits: ["rejectTextContent"],
  setup(o) {
    let e = 0;
    function n() {
      e = Date.now();
    }
    const t = K();
    function i() {
      Date.now() - e < 200 && window.setTimeout(() => {
        t.selectElement(null);
      });
    }
    const s = I(!0), { ratioRef: r } = X();
    return (a, l) => (b(), k("g", {
      transform: `translate(${a.element.position.x}, ${a.element.position.y}) rotate(${a.element.angleRadian * 180 / Math.PI})`,
      onPointerdownPassive: l[3] || (l[3] = B(() => {
      }, ["stop"]))
    }, [
      R("rect", {
        class: "stroke-orange",
        "fill-opacity": "0",
        height: a.element.height,
        "stroke-width": S(r),
        width: a.element.width,
        onPointerdownPassive: n,
        onPointerupPassive: i
      }, null, 40, Hi),
      R("g", {
        style: be({ visibility: s.value && !a.element.isLocked ? "visible" : "hidden" }),
        onPointerdownPassive: n,
        onPointerupPassive: i
      }, [
        S(Dn)(a.element) ? (b(), $(Pi, {
          key: 0,
          element: a.element
        }, null, 8, ["element"])) : E("", !0),
        S(Kn)(a.element) ? (b(), $(Ci, {
          key: 1,
          element: a.element
        }, null, 8, ["element"])) : E("", !0),
        S(An)(a.element) ? (b(), $(zi, {
          key: 2,
          element: a.element
        }, null, 8, ["element"])) : E("", !0),
        S(Fn)(a.element) ? (b(), $(Fi, {
          key: 3,
          element: a.element
        }, null, 8, ["element"])) : E("", !0)
      ], 36),
      S(We)(a.element) ? (b(), $(Wi, {
        key: 0,
        element: a.element,
        onEnd: l[0] || (l[0] = (c) => s.value = !0),
        onRejectTextContent: l[1] || (l[1] = (c) => a.$emit("rejectTextContent", c)),
        onStart: l[2] || (l[2] = (c) => s.value = !1)
      }, null, 8, ["element"])) : E("", !0)
    ], 40, Gi));
  }
}), Yi = 15, Xi = /* @__PURE__ */ O({
  __name: "ToolMenu",
  props: {
    anchor: {},
    boundary: {},
    element: {},
    viewableRect: {}
  },
  emits: ["clickButton"],
  setup(o, { emit: e }) {
    const n = o, t = e, i = Y("toolMenuRef"), { ratioRef: s, viewBoxToScreen: r } = X(), a = x(() => {
      const g = i.value;
      if (g === null)
        return { x: 0, y: 0 };
      const { x: f, y: h } = n.anchor, { left: w, right: p } = n.boundary, { width: _, height: C } = g.getBoundingClientRect(), M = r(n.element.boundingRect);
      return {
        x: Math.max(Math.min(M.x - f + (M.width - _) / 2, p - _), w),
        y: Math.max(M.y - h - C - Yi, 0)
      };
    }), l = K();
    function c(g) {
      const f = new zt(g);
      l.execute(f), t(
        "clickButton",
        "edit",
        `design area edit ${A.typeOf(n.element) ?? "undefined"}`
      );
    }
    function m(g) {
      l.removeElement(g), t(
        "clickButton",
        "remove",
        `design area delete ${A.typeOf(n.element) ?? "undefined"}`
      );
    }
    function d(g) {
      const f = s.value, { x: h, y: w } = n.element.position, p = F(g, (_) => {
        _.updateData({
          ..._.data,
          position: {
            x: h + 20 * f,
            y: w + 20 * f
          }
        });
      });
      l.appendElement(p), t(
        "clickButton",
        "duplicate",
        `design area duplicate ${A.typeOf(n.element) ?? "undefined"}`
      );
    }
    function u(g) {
      const f = new _o(g, n.viewableRect);
      l.execute(f), t(
        "clickButton",
        "expand",
        `design area expand ${A.typeOf(n.element) ?? "undefined"}`
      );
    }
    function y(g) {
      const f = new ko(g);
      l.execute(f);
    }
    return (g, f) => (b(), k("div", {
      ref_key: "toolMenuRef",
      ref: i,
      class: "shadow-btn-shadow absolute h-40px flex items-center justify-center rounded-100px bg-white px-12px",
      style: be({
        top: `${a.value.y}px`,
        left: `${a.value.x}px`,
        visibility: g.element.isOperating ? "hidden" : "visible"
      }),
      onPointerdown: f[5] || (f[5] = B(() => {
      }, ["stop"]))
    }, [
      R("button", {
        type: "button",
        onClickPassive: f[0] || (f[0] = B((h) => m(g.element), ["stop"]))
      }, f[6] || (f[6] = [
        R("i", { class: "icon-trash" }, null, -1)
      ]), 32),
      S(Tn)(g.element) ? (b(), k("button", {
        key: 0,
        type: "button",
        onClickPassive: f[1] || (f[1] = B((h) => d(g.element), ["stop"]))
      }, f[7] || (f[7] = [
        R("i", { class: "icon-copy" }, null, -1)
      ]), 32)) : E("", !0),
      S(We)(g.element) ? (b(), k("button", {
        key: 1,
        type: "button",
        onClickPassive: f[2] || (f[2] = B((h) => c(g.element), ["stop"]))
      }, f[8] || (f[8] = [
        R("i", { class: "icon-edit" }, null, -1)
      ]), 32)) : E("", !0),
      S(Jn)(g.element) ? (b(), k("button", {
        key: 2,
        type: "button",
        onClickPassive: f[3] || (f[3] = B((h) => u(g.element), ["stop"]))
      }, f[9] || (f[9] = [
        R("i", { class: "icon-full-page" }, null, -1)
      ]), 32)) : E("", !0),
      S(eo)(g.element) ? (b(), k("button", {
        key: 3,
        type: "button",
        onClickPassive: f[4] || (f[4] = B((h) => y(g.element), ["stop"]))
      }, f[10] || (f[10] = [
        R("i", { class: "icon-mirror" }, null, -1)
      ]), 32)) : E("", !0)
    ], 36));
  }
}), Ki = /* @__PURE__ */ He(Xi, [["__scopeId", "data-v-0e95214a"]]), Ns = /* @__PURE__ */ O({
  __name: "DesignCanvas",
  props: {
    designRect: {},
    maskMode: { default: "basic" },
    previewMaskUrl: {},
    printMaskUrl: {},
    svgExpandSize: { default: 0 },
    viewableRect: {},
    viewBoxSize: {}
  },
  emits: ["clickButton", "rejectTextContent", "updatePrintAreaWarning"],
  setup(o, { expose: e, emit: n }) {
    const t = o, i = n;
    e({ exportDom: d });
    function s(h) {
      const w = h.currentTarget;
      w.scrollLeft = 0;
    }
    const r = K(), a = Y("containerDiv"), l = x(() => {
      const h = r.selectedElement;
      return h !== null && h.isOperating && !(We(h) && h.isContentEditing) && t.maskMode === "basic";
    });
    N(l, (h) => {
      i("updatePrintAreaWarning", h ? "show" : "hide");
    });
    const c = Y("designSvg"), m = x(
      () => {
        var h;
        return (
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          ((h = c.value) == null ? void 0 : h.containerRect) ?? {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          }
        );
      }
    );
    async function d({ onlyDesign: h = !1, excludeArtwork: w = !1 }) {
      r.selectElement(null), await mn();
      const p = c.value;
      if (p === null)
        throw new Error("<DesignSvg> not mounted");
      return p.exportDom({
        onlyDesign: h,
        excludeArtwork: w
      });
    }
    const u = Gt(a), y = x(() => u.value.height + t.svgExpandSize), g = x(() => {
      const { x: h, width: w } = u.value, { x: p, width: _ } = m.value;
      return {
        left: Math.max(0, p - h),
        right: Math.min(w, p + _ - h)
      };
    }), f = `displayAnchor-${Ue()}`;
    return De(Ht, { displayAnchorId: f }), De(Ge, {
      viewBoxSize: x(() => t.viewBoxSize),
      containerRect: m
    }), gn(() => {
      r.selectElement(null);
    }), (h, w) => (b(), k("div", {
      ref_key: "containerDiv",
      ref: a,
      class: "relative flex touch-none items-center justify-center overflow-hidden",
      onPointerdownPassive: w[2] || (w[2] = B((p) => S(r).selectElement(null), ["stop"])),
      onScroll: s
    }, [
      fn(wi, {
        ref_key: "designSvg",
        ref: c,
        class: "shrink-0",
        design: S(r).design,
        "design-rect": h.designRect,
        "mask-mode": t.maskMode,
        "preview-mask-url": h.previewMaskUrl,
        "print-mask-url": h.printMaskUrl,
        "selected-element-id": S(r).selectedElementId,
        "show-print-area-warning": l.value,
        style: be({
          "margin-top": `-${t.svgExpandSize / 2}px`,
          width: `${y.value}px`,
          height: `${y.value}px`
        }),
        viewBoxSize: h.viewBoxSize,
        onSelect: S(r).selectElement
      }, {
        "pre-design": Me(() => [
          se(h.$slots, "pre-design")
        ]),
        "post-design": Me(() => [
          se(h.$slots, "post-design")
        ]),
        "design-handle": Me(() => [
          S(r).selectedElement ? (b(), $(Ni, {
            key: 0,
            element: S(r).selectedElement,
            onRejectTextContent: w[0] || (w[0] = (p) => h.$emit("rejectTextContent", p))
          }, null, 8, ["element"])) : E("", !0),
          R("g", { id: f })
        ]),
        _: 3
      }, 8, ["design", "design-rect", "mask-mode", "preview-mask-url", "print-mask-url", "selected-element-id", "show-print-area-warning", "style", "viewBoxSize", "onSelect"]),
      S(r).selectedElement && !S(r).selectedElement.isLocked ? (b(), $(Ki, {
        key: 0,
        anchor: S(u),
        boundary: g.value,
        element: S(r).selectedElement,
        "viewable-rect": h.viewableRect,
        onClickButton: w[1] || (w[1] = (p, _) => h.$emit("clickButton", p, _))
      }, null, 8, ["anchor", "boundary", "element", "viewable-rect"])) : E("", !0)
    ], 544));
  }
});
function Xt(o, e, n, t, i, s) {
  const r = [], a = Math.floor(t);
  for (let l = 0; l < n; l++)
    for (let c = 0; c < e; c++) {
      const m = c + l * e;
      let d = o[m];
      const u = Math.min(e, c + a + 1), y = Math.min(n, l + a + 1);
      for (let g = Math.max(0, l - a); d !== s && g < y; g++)
        for (let f = Math.max(0, c - a); d !== s && f < u; f++) {
          const h = f + g * e;
          d = i(d, o[h]);
        }
      r.push(d);
    }
  return r;
}
function Zi(o, e, n, t) {
  return Xt(o, e, n, t, (i, s) => i && s, !1);
}
function qi(o, e, n, t) {
  return Xt(o, e, n, t, (i, s) => i || s, !0);
}
const Ve = /* @__PURE__ */ new Map();
async function Ys(o) {
  if (Ve.has(o)) return;
  const { width: e, height: n } = await Zt(o), t = await Ye(o, e, n, 1, !0);
  Ve.set(o, t);
}
async function Xs(o, e, n, t = 1, i, s = 0, r = "image/png") {
  const a = o.cloneNode(!0);
  await Kt(a, t, i);
  const l = URL.createObjectURL(
    new Blob([a.outerHTML], {
      type: "image/svg+xml"
    })
  ), c = await Ye(
    l,
    e,
    n,
    t,
    !1,
    s,
    r
  );
  return URL.revokeObjectURL(l), Ji(c);
}
function Ji(o) {
  const e = /data:(?<mime>image\/[A-Za-z]*);base64,(?<data>[^"]*)/.exec(o);
  if ((e == null ? void 0 : e.groups) === void 0)
    throw new Error(`dataURL format error: ${o}`);
  const n = e.groups.mime ?? "", t = e.groups.data ?? "";
  if (n.length === 0 || t.length === 0)
    throw new Error(`dataURL format error: ${o}`);
  const i = atob(t), s = new ArrayBuffer(i.length), r = new Uint8Array(s);
  for (let a = 0; a < i.length; a++) {
    const l = i.codePointAt(a);
    l !== void 0 && (r[a] = l);
  }
  return new Blob([s], { type: n });
}
async function Kt(o, e, n) {
  o instanceof SVGImageElement && await Qi(o, e, n);
  for (const t of o.childNodes)
    await Kt(t, e, n);
}
async function Qi(o, e, n) {
  const t = o.href.baseVal;
  if (t.length === 0) return;
  const i = Ve.get(t);
  if (i !== void 0) {
    o.setAttribute("href", i);
    return;
  }
  const s = o.width.baseVal.value, r = o.height.baseVal.value;
  try {
    const a = await Ye(t, s, r, e);
    o.setAttribute("href", a);
  } catch (a) {
    if ((n == null ? void 0 : n(o)) === !0)
      o.setAttribute("href", "");
    else
      throw a;
  }
}
async function Zt(o, e = !1) {
  const n = new Image();
  n.crossOrigin = "anonymous";
  const t = new URL(o);
  return e && ["http:", "https:"].includes(t.protocol) && t.searchParams.set("do-not-use-cached-resource", Date.now().toString()), n.src = t.toString(), await new Promise((i, s) => {
    n.addEventListener("load", () => {
      i(n);
    }), n.addEventListener("error", s);
  });
}
async function Ye(o, e, n, t = 1, i = !1, s = 0, r = "image/png") {
  const a = await Zt(o, !0);
  await Ne();
  const l = document.createElement("canvas");
  l.width = e * t, l.height = n * t, i && (l.width = a.width, l.height = a.height);
  const c = es(l.width, l.height);
  l.width = c.width, l.height = c.height;
  const m = l.getContext("2d");
  if (m === null)
    throw new TypeError("canvas.getContext('2d') failed");
  if (m.drawImage(a, 0, 0, l.width, l.height), s > 0) {
    const d = Math.floor(l.width), u = Math.floor(l.height), y = ts(m, d, u);
    let g = Zi(y, d, u, s);
    g = qi(g, d, u, s), m.clearRect(0, 0, l.width, l.height), m.fillStyle = "#F00";
    for (let f = 0; f < u; f++)
      for (let h = 0; h < d; h++) {
        const w = h + f * e;
        y[w] && !g[w] && m.fillRect(h, f, 1, 1);
      }
  }
  return l.toDataURL(r);
}
const dt = 4096, ut = 4096;
function es(o, e) {
  let n = 1;
  return o > dt && (n *= dt / o), e > ut && (n *= ut / e), { width: Math.floor(o * n), height: Math.floor(e * n) };
}
function ts(o, e, n) {
  const i = o.getImageData(0, 0, e, n).data, s = [];
  for (let r = 3; r < i.length; r += 4)
    s.push(i[r] > 0);
  return s;
}
const ns = /@font-face\s*{([\s\S]*?)}/gm, os = /^\s*(?<name>[\w-]+)\s*:\s*(?<value>[\s\S]*?)\s*$/, qt = /url\((.*?)\)/;
function ve(o) {
  return o.startsWith("'") || o.startsWith('"') ? o.substring(1, o.length - 1).replaceAll("\\'", "'").replaceAll('\\"', '"') : o;
}
function is(o) {
  if (!(o instanceof Error)) return !1;
  const e = o.name;
  return e === "SECURITY_ERR" || e === "SecurityError";
}
function ss(o, e, n = jt) {
  const t = o.cssRules;
  for (const i of t) {
    if (!(i instanceof CSSFontFaceRule)) continue;
    const s = i.style, r = qt.exec(s.getPropertyValue("src"));
    if (r === null) continue;
    const a = ve(s.getPropertyValue("font-family"));
    let l = e.get(a);
    l === void 0 && (l = [], e.set(a, l)), l.push({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      src: ve(r[1]),
      unicodeRange: n(s.getPropertyValue("unicode-range"))
    });
  }
}
async function rs(o, e, n = jt) {
  var r;
  const s = (await (await fetch(o)).text()).matchAll(ns);
  for (const a of s) {
    let l, c, m;
    const d = ((r = a[1]) == null ? void 0 : r.split(";")) ?? [];
    for (const y of d) {
      const g = os.exec(y);
      if (g === null) continue;
      const { name: f = "", value: h = "" } = g.groups ?? {};
      switch (f) {
        case "font-family": {
          l = ve(h);
          break;
        }
        case "src": {
          if (c !== void 0) continue;
          const w = qt.exec(h);
          if (w === null) continue;
          c = ve(w[1]);
          break;
        }
        case "unicode-range": {
          m = n(h);
          break;
        }
      }
    }
    if (l === void 0 || c === void 0) continue;
    let u = e.get(l);
    u === void 0 && (u = [], e.set(l, u)), u.push({ src: c, unicodeRange: m });
  }
}
async function Ks() {
  const o = /* @__PURE__ */ new Map(), e = [];
  for (const n of document.styleSheets)
    try {
      ss(n, o);
    } catch (t) {
      if (!is(t)) throw t;
      const i = n.href;
      if (i === null) continue;
      const s = rs(i, o);
      e.push(s);
    }
  return await Promise.all(e), o;
}
const Zs = {
  install(o, { fontUtil: e, designStorage: n }) {
    o.provide(It, e), o.provide(Yt, n);
  }
};
export {
  wo as AppendElementCommand,
  Ms as ChangeElementBackgroundColorCommand,
  Ps as ChangeElementBackgroundRadiusCommand,
  $s as ChangeElementColorCommand,
  Os as ChangeElementFontFamilyCommand,
  bo as ClearDesignCommand,
  Ts as CompositeCommand,
  H as CropElementCommand,
  Ns as DesignCanvas,
  Eo as DesignSerializer,
  wi as DesignSvg,
  zt as EditElementContentCommand,
  _o as ExpandElementToFullPageCommand,
  To as FontFace,
  Ds as HorizontallyCenterElementCommand,
  ko as MirrorElementCommand,
  lt as MoveElementCommand,
  Ro as RemoveElementCommand,
  So as ReorderElementCommand,
  ct as RotateElementCommand,
  Pe as ScaleElementCommand,
  Bs as SetElementBorderColorCommand,
  Fs as SetElementBorderRadiusCommand,
  Ls as SetElementBorderWidthCommand,
  As as SetElementCurvatureCommand,
  Vs as SetElementStackGapRatioCommand,
  Us as SetElementStackOffsetRatioCommand,
  zs as SetNumElementStackColumnsCommand,
  js as SetNumElementStackRowsCommand,
  Do as TextRenderer,
  Is as ToggleBackgroundVisibilityCommand,
  Ws as ToggleElementLockCommand,
  Gs as ToggleElementVisibilityCommand,
  Co as UpdateBackgroundCommand,
  Hs as VerticallyCenterElementCommand,
  le as backgroundRegistry,
  _s as createBarcodeElement,
  Mo as createDesign,
  Ut as createDesignState,
  vs as createImageBackground,
  Rs as createPhotoElement,
  ws as createPlainColorBackground,
  Cs as createStickerElement,
  xs as createTextElement,
  jt as createUnicodeRange,
  A as elementRegistry,
  Ks as getWebFontFaceRules,
  Gn as isBarcodeElement,
  ks as isBordered,
  Tn as isCloneable,
  We as isContentEditable,
  Kn as isCroppable,
  Jn as isFullPageable,
  Cn as isImageBackground,
  eo as isMirrorable,
  Dn as isMovable,
  io as isPhotoElement,
  Pn as isPlainColorBackground,
  Fn as isRotatable,
  An as isScalable,
  Ss as isStackable,
  lo as isStickerElement,
  po as isTextElement,
  Zs as plugin,
  bs as setBarcodeElementOptions,
  Ys as setCachedDataUrl,
  Es as setTextElementOptions,
  Xs as svgToImageBlob,
  K as useDesignStore
};
//# sourceMappingURL=index.js.map
